const tokens = {
  "color": {
    "blue": {
      "25": "#F5F9FF",
      "50": "#E5EFFF",
      "100": "#CCDFFF",
      "200": "#99C0FF",
      "300": "#68A2FF",
      "350": "#408AFF",
      "400": "#3381FF",
      "450": "#277BFF",
      "475": "#106CFF",
      "500": "#0062FF",
      "600": "#004ECC",
      "700": "#0044B2",
      "800": "#003B99",
      "900": "#003180",
      "950": "#002766",
      "975": "#001D4C"
    },
    "green": {
      "25": "#F7FDF9",
      "50": "#EAFAF0",
      "100": "#D6F5E1",
      "200": "#ADEBC4",
      "300": "#84E1A6",
      "400": "#46D27A",
      "500": "#2FC063",
      "600": "#28A455",
      "700": "#23904B",
      "800": "#1E7B40",
      "900": "#196735",
      "950": "#14522B",
      "975": "#0F3E20"
    },
    "red": {
      "25": "#FFF7F7",
      "50": "#FEE6E6",
      "100": "#FDCECE",
      "200": "#FB9D9D",
      "300": "#FA7979",
      "400": "#F94C4C",
      "500": "#F60909",
      "600": "#C71C1C",
      "700": "#AC0606",
      "800": "#940505",
      "900": "#7B0404",
      "950": "#620404",
      "975": "#4A0303"
    },
    "yellow": {
      "25": "#FFFCF5",
      "50": "#FFF8E6",
      "100": "#FEF2CC",
      "200": "#FEE59A",
      "300": "#FDD868",
      "400": "#FCC51C",
      "500": "#FDA502",
      "600": "#F79008",
      "700": "#DC6803",
      "800": "#B54708",
      "900": "#93370D",
      "950": "#792E0D",
      "975": "#592007"
    },
    "grey": {
      "25": "#FAFCFF",
      "50": "#F5F7F9",
      "75": "#EFF2F6",
      "100": "#EBEDF0",
      "150": "#E0E3E8",
      "200": "#D6DBE4",
      "250": "#CCD2DD",
      "300": "#C4CBD6",
      "400": "#A9B0BC",
      "500": "#8F909E",
      "600": "#666A73",
      "700": "#4E5158",
      "800": "#43464B",
      "900": "#3A3C41",
      "950": "#292A2E",
      "975": "#202124",
      "980": "#161819",
      "1000": "#111314"
    },
    "whiteAlpha": {
      "50": "#FFFFFF0D",
      "100": "#FFFFFF1A",
      "200": "#FFFFFF33",
      "300": "#FFFFFF4D",
      "400": "#FFFFFF66",
      "500": "#FFFFFF80",
      "600": "#FFFFFF99",
      "700": "#FFFFFFB3",
      "800": "#FFFFFFCC",
      "900": "#FFFFFFE6",
      "1000": "#FFFFFF"
    },
    "blackAlpha": {
      "50": "#1113140D",
      "100": "#1113141A",
      "200": "#11131433",
      "300": "#1113144D",
      "400": "#11131466",
      "500": "#11131480",
      "600": "#11131499",
      "700": "#111314B3",
      "800": "#111314CC",
      "900": "#111314E6",
      "1000": "#111314"
    },
    "peach": {
      "100": "#F7CBA7",
      "200": "#F4BB8C",
      "300": "#F2A970",
      "400": "#FC9549",
      "500": "#FF7008",
      "600": "#DC5D00"
    },
    "salad": {
      "100": "#CBFC6F",
      "200": "#BEFC58",
      "300": "#B1F84E",
      "400": "#9CD340",
      "500": "#65A400",
      "600": "#658E29"
    },
    "tiffany": {
      "100": "#89EAFC",
      "200": "#75E7FC",
      "300": "#6AE2FB",
      "400": "#53DBED",
      "500": "#00ACC2",
      "600": "#4295A7"
    },
    "violet": {
      "100": "#C8B4F6",
      "200": "#BBA1F4",
      "300": "#AD8EF2",
      "400": "#B996F5",
      "500": "#9A64F7",
      "600": "#7646EC"
    },
    "pink": {
      "100": "#EFBED0",
      "200": "#EBAEC5",
      "300": "#E590AE",
      "400": "#F179A4",
      "500": "#D9477C",
      "600": "#C03D67"
    },
    "gradient": {
      "mars": {
        "1": "#360E44",
        "2": "#BA3C71",
        "3": "#FFA37B"
      },
      "neptune": {
        "1": "#000E57",
        "2": "#0087B4",
        "3": "#2CFFA7"
      },
      "moon": {
        "1": "#161E21",
        "2": "#516573",
        "3": "#EAEAEA"
      },
      "mercury": {
        "1": "#B81F56",
        "2": "#E07B32",
        "3": "#EDDC82"
      },
      "saturn": {
        "1": "#000F2B",
        "2": "#2B778E",
        "3": "#FFFCA8"
      },
      "pluto": {
        "1": "#0D2700",
        "2": "#B17C16",
        "3": "#FFE5A2"
      },
      "jupiter": {
        "1": "#330033",
        "2": "#8D008D",
        "3": "#FFF435"
      },
      "uranus": {
        "1": "#000744",
        "2": "#4A54B2",
        "3": "#C3E2FE"
      },
      "venus": {
        "1": "#170035",
        "2": "#541CB0",
        "3": "#D3A8FF"
      },
      "earth": {
        "1": "#0D3325",
        "2": "#389864",
        "3": "#D8FF68"
      }
    }
  },
  "spacing": {
    "2": 2,
    "4": 4,
    "6": 6,
    "8": 8,
    "12": 12,
    "16": 16,
    "24": 24,
    "32": 32,
    "40": 40,
    "48": 48,
    "56": 56,
    "64": 64,
    "72": 72,
    "80": 80,
    "88": 88,
    "96": 96
  },
  "radius": {
    "2": 2,
    "4": 4,
    "6": 6,
    "8": 8,
    "10": 10,
    "12": 12,
    "16": 16,
    "24": 24,
    "32": 32,
    "360": 360
  },
  "buttonSize": {
    "16": 16,
    "20": 20,
    "24": 24,
    "32": 32,
    "40": 40,
    "48": 48,
    "56": 56
  },
  "borderThickness": {
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "iconSize": {
    "4": 4,
    "6": 6,
    "8": 8,
    "10": 10,
    "12": 12,
    "14": 14,
    "16": 16,
    "20": 20,
    "24": 24,
    "32": 32,
    "40": 40,
    "48": 48,
    "56": 56,
    "64": 64
  },
  "theme": {
    "dark": {
      "color": {
        "brand": {
          "disableText": "#FFFFFF33",
          "disable": "#FFFFFF0D",
          "press": "#FFFFFF1A",
          "hover": "#FFFFFF33",
          "transparent": "#FFFFFF1A",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "successBackground": "#2FC063",
          "successContent": "#46D27A",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "accent": "#FAFCFF",
          "additional": "#68A2FF",
          "lowContrast": "#99C0FF",
          "contrast": "#FAFCFF",
          "dark": "#0044B2",
          "light": "#68A2FF",
          "main": "#0062FF"
        },
        "blueElevation1": {
          "status5": "#F179A4",
          "status4": "#B996F5",
          "status3": "#53DBED",
          "status2": "#9CD340",
          "status1": "#FC9549",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "transparent": "#FFFFFF0D",
          "accent": "#68A2FF",
          "additional": "#277BFF",
          "lowContrast": "#99C0FF",
          "contrast": "#FAFCFF",
          "main": "#003180"
        },
        "blueElevation2": {
          "status5": "#F179A4",
          "status4": "#B996F5",
          "status3": "#53DBED",
          "status2": "#9CD340",
          "status1": "#FC9549",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "accent": "#68A2FF",
          "additional": "#277BFF",
          "lowContrast": "#99C0FF",
          "contrast": "#FAFCFF",
          "main": "#003B99"
        },
        "onBrand": {
          "press": "#FFFFFF1A",
          "hover": "#EBEDF066",
          "transparent": "#1113141A",
          "accent": "#3381FF",
          "additional": "#C4CBD6",
          "lowContrast": "#8F909E",
          "contrast": "#202124",
          "main": "#EBEDF0"
        },
        "elevation0": {
          "dark": "#111314",
          "light": "#202124",
          "main": "#111314"
        },
        "elevation1": {
          "dark": "#111314",
          "light": "#292A2E",
          "main": "#161819"
        },
        "elevation2": {
          "dark": "#161819",
          "light": "#3A3C41",
          "main": "#202124"
        },
        "elevation3": {
          "main": "#292A2E"
        },
        "elevationObject": {
          "main": "#161819"
        },
        "transparent5": {
          "main": "#FFFFFF0D"
        },
        "staticBlack80": {
          "main": "#111314CC"
        },
        "staticBlack60": {
          "main": "#11131499"
        },
        "lines": {
          "borderAccent": "#68A2FF",
          "border": "#3A3C41",
          "dividerBright": "#FFFFFF33",
          "divider": "#FFFFFF0D"
        },
        "static": {
          "darkLowContrast": "#11131433",
          "dark": "#202124",
          "lightLowContrast": "#FFFFFF33",
          "light": "#FAFCFF"
        },
        "common": {
          "status5Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#E590AE",
          "status4Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#AD8EF2",
          "status3Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status2Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status1Contrast": "#111314",
          "status1Background": "#FC9549",
          "status1Content": "#F2A970",
          "infoContrast": "#111314",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "errorContrast": "#FAFCFF",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "warningContrast": "#111314",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "successContrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "disableText": "#FFFFFF33",
          "disable": "#FFFFFF0D",
          "transparent": "#FFFFFF0D",
          "focus": "#FFFFFF1A",
          "press": "#FFFFFF0D",
          "hover": "#FFFFFF1A",
          "lowAccent": "#FFFFFF33",
          "accent": "#68A2FF",
          "additional": "#666A73",
          "lowContrast": "#8F909E",
          "contrast": "#FAFCFF"
        },
        "gradients": {
          "mars": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#360E44",
              "2": "#BA3C71",
              "3": "#FFA37B"
            }
          },
          "venus": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#170035",
              "2": "#541CB0",
              "3": "#D3A8FF"
            }
          },
          "neptune": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#000E57",
              "2": "#0087B4",
              "3": "#2CFFA7"
            }
          },
          "mercury": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#B81F56",
              "2": "#E07B32",
              "3": "#EDDC82"
            }
          },
          "earth": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#0D3325",
              "2": "#389864",
              "3": "#D8FF68"
            }
          },
          "uranus": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#000744",
              "2": "#4A54B2",
              "3": "#C3E2FE"
            }
          },
          "jupiter": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#330033",
              "2": "#8D008D",
              "3": "#FFF435"
            }
          },
          "moon": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#161E21",
              "2": "#516573",
              "3": "#EAEAEA"
            }
          },
          "saturn": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#000F2B",
              "2": "#2B778E",
              "3": "#FFFCA8"
            }
          },
          "pluto": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#0D2700",
              "2": "#B17C16",
              "3": "#FFE5A2"
            }
          }
        },
        "success": {
          "contrast": "#111314",
          "dark": "#23904B",
          "light": "#84E1A6",
          "main": "#46D27A",
          "mainContent": "#46D27A"
        },
        "warning": {
          "contrast": "#111314",
          "dark": "#FDA502",
          "light": "#FEE59A",
          "main": "#FCC51C",
          "mainContent": "#FDD868"
        },
        "error": {
          "contrast": "#FAFCFF",
          "dark": "#F60909",
          "light": "#FA7979",
          "main": "#F94C4C",
          "mainContent": "#FA7979"
        },
        "info": {
          "contrast": "#111314",
          "dark": "#3381FF",
          "light": "#99C0FF",
          "main": "#68A2FF",
          "mainContent": "#99C0FF"
        },
        "status1": {
          "contrast": "#111314",
          "dark": "#FF7008",
          "light": "#F2A970",
          "main": "#FC9549",
          "mainContent": "#F2A970"
        },
        "status2": {
          "contrast": "#111314",
          "dark": "#65A400",
          "light": "#B1F84E",
          "main": "#9CD340",
          "mainContent": "#9CD340"
        },
        "status3": {
          "contrast": "#111314",
          "dark": "#00ACC2",
          "light": "#6AE2FB",
          "main": "#53DBED",
          "mainContent": "#53DBED"
        },
        "status4": {
          "contrast": "#111314",
          "dark": "#9A64F7",
          "light": "#AD8EF2",
          "main": "#B996F5",
          "mainContent": "#AD8EF2"
        },
        "status5": {
          "contrast": "#111314",
          "dark": "#D9477C",
          "light": "#E590AE",
          "main": "#F179A4",
          "mainContent": "#E590AE"
        },
        "dionCommon": {
          "status5Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#E590AE",
          "status4Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#AD8EF2",
          "status3Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status2Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status1Contrast": "#111314",
          "status1Background": "#FC9549",
          "status1Content": "#F2A970",
          "infoContrast": "#111314",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "errorContrast": "#FAFCFF",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "warningContrast": "#111314",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "successContrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "disableText": "#FFFFFF33",
          "disable": "#FFFFFF0D",
          "transparent": "#FFFFFF0D",
          "focus": "#FFFFFF1A",
          "press": "#FFFFFF0D",
          "hover": "#FFFFFF1A",
          "lowAccent": "#FFFFFF33",
          "accent": "#68A2FF",
          "additional": "#666A73",
          "lowContrast": "#8F909E",
          "contrast": "#FAFCFF"
        }
      },
      "radius": {
        "xxxxxl": 360,
        "xxl": 32,
        "xl": 24,
        "l": 16,
        "m": 12,
        "s": 8,
        "xs": 6,
        "xxs": 4,
        "none": 0
      },
      "spacing": {
        "general": {
          "xxxxxl": 56,
          "xxxxl": 48,
          "xxxl": 40,
          "xxl": 32,
          "xl": 24,
          "l": 16,
          "m": 12,
          "s": 8,
          "xs": 6,
          "xxs": 4,
          "none": 0
        }
      },
      "avatar": {
        "letterCount": {
          "xxxl": 2,
          "xxl": 2,
          "xl": 2,
          "l": 2,
          "m": 2,
          "s": 2,
          "xs": 1
        },
        "variant": {
          "rounded": {
            "borderRadius": 50
          },
          "square": {
            "borderRadius": 25
          }
        },
        "size": {
          "avatar": {
            "xxxl": 128,
            "xxl": 96,
            "xl": 56,
            "l": 48,
            "m": 40,
            "s": 32,
            "xs": 24
          },
          "icon": {
            "xxxl": "xxxxxl",
            "xxl": "xxxxl",
            "xl": "xl",
            "l": "l",
            "m": "m",
            "s": "s",
            "xs": "xs"
          }
        },
        "typography": {
          "xxxl": "h2",
          "xxl": "h2",
          "xl": "h6",
          "l": "button1",
          "m": "button2",
          "s": "caption1",
          "xs": "caption1"
        },
        "controls": {
          "counter": {
            "size": {
              "xxxl": 24,
              "xxl": 20,
              "xl": 16,
              "l": 16,
              "m": 16,
              "s": 12,
              "xs": 12
            },
            "border": {
              "xxxl": 4,
              "xxl": 3,
              "xl": 2,
              "l": 2,
              "m": 2,
              "s": 2,
              "xs": 2
            },
            "typography": {
              "xxxl": "h5",
              "xxl": "h6",
              "xl": "body2",
              "l": "body2",
              "m": "body2",
              "s": "caption1",
              "xs": "caption2"
            },
            "radius": {
              "xxxl": 32,
              "xxl": 8,
              "xl": 8,
              "l": 8,
              "m": 8,
              "s": 8,
              "xs": 8
            }
          },
          "online": {
            "icon": "Fill",
            "size": {
              "xxxl": 16,
              "xxl": 16,
              "xl": 8,
              "l": 8,
              "m": 6,
              "s": 6,
              "xs": 4
            },
            "border": {
              "xxxl": 5,
              "xxl": 3,
              "xl": 2,
              "l": 2,
              "m": 2,
              "s": 2,
              "xs": 2
            },
            "iconSize": {
              "xxxl": "l",
              "xxl": "m",
              "xl": "xs",
              "l": "xs",
              "m": "xxs",
              "s": "xxs",
              "xs": "xxxs"
            }
          },
          "slot": {
            // TODO: передать фиксы по токенам в фигму
            "size": {
              "xxxl": 44,
              "xxl": 40,
              "xl": 24,
              "l": 20,
              "m": 20,
              "s": 20,
              "xs": 16
            },
            "border": {
              "xxxl": 4,
              "xxl": 3,
              "xl": 2,
              "l": 2,
              "m": 2,
              "s": 2,
              "xs": 2
            },
            "iconSize": {
              "xxxl": "xl",
              "xxl": "l",
              "xl": "s",
              "l": "xs",
              "m": "xs",
              "s": "xs",
              "xs": "xxs"
            }
          },
          "close": {
            "icon": "delete_small",
            "border": {
              "xxxl": 3,
              "xxl": 3,
              "xl": 2,
              "l": 2,
              "m": 2,
              "s": 2,
              "xs": 2
            },
            "size": {
              "xxxl": 24,
              "xxl": 24,
              "xl": 16,
              "l": 16,
              "m": 16,
              "s": 16,
              "xs": 12
            },
            "iconSize": {
              "xxxl": "l",
              "xxl": "l",
              "xl": "s",
              "l": "s",
              "m": "s",
              "s": "s",
              "xs": "xs"
            }
          }
        }
      },
      "border": {
        "xl": 5,
        "l": 4,
        "m": 3,
        "s": 2,
        "xs": 1
      },
      "button": {
        "spacing": {
          "xl": 24,
          "l": 16,
          "m": 16,
          "s": 12,
          "xs": 8,
          "xxs": 4,
          "xxxs": 4
        },
        "borderRadius": {
          "xl": 12,
          "l": 8,
          "m": 8,
          "s": 8,
          "xs": 6,
          "xxs": 4,
          "xxxs": 4
        },
        "size": {
          "xl": 56,
          "l": 48,
          "m": 40,
          "s": 32,
          "xs": 24,
          "xxs": 20,
          "xxxs": 16,
          "icon": {
            "xl": "l",
            "l": "m",
            "m": "m",
            "s": "s",
            "xs": "s",
            "xxs": "s",
            "xxxs": "xs"
          },
          "typography": {
            "xl": "button1",
            "l": "button1",
            "m": "button1",
            "s": "button2",
            "xs": "button2",
            "xxs": "body2",
            "xxxs": "caption2"
          }
        }
      },
      "buttonGroup": {
        "spacing": {
          "m": 16
        }
      },
      "dialog": {
        "borderRadius": 16
      },
      "drawer": {
        "borderRadius": {
          "top": 16
        },
        "spacing": {
          "actionsBottomMargin": 56,
          "actionsTopMargin": 24,
          "subtitleTopMargin": 24,
          "titleBottomMargin": 24,
          "margin": 24
        }
      },
      "sidePanel": {
        "spacing": {
          "titleMargin": 16,
          "margin": 24,
          "actionsMargin": 24
        }
      },
      "icon": {
        "size": {
          "xxxxxl": 64,
          "xxxxl": 56,
          "xxxl": 48,
          "xxl": 40,
          "xl": 32,
          "l": 24,
          "m": 20,
          "s": 16,
          "xs": 12,
          "xxs": 10,
          "xxxs": 8,
          "xxxxs": 6,
          "xxxxxs": 4
        }
      },
      "input": {
        "margin": {
          "m": {
            "bottom": 8,
            "top": 8
          },
          "l": {
            "bottom": 8,
            "top": 8
          }
        },
        "padding": {
          "m": {
            "content": 12,
            "icon": 8
          },
          "l": {
            "content": 16,
            "icon": 12
          }
        },
        "borderRadius": {
          "l": 8,
          "m": 8
        },
        "size": {
          "l": 48,
          "m": 40
        },
        "typography": {
          "m": {
            "additional": "caption1",
            "mainText": "body1",
            "placeholder": "body1",
            "counter": "body2",
            "label": "body2"
          },
          "l": {
            "additional": "caption1",
            "mainText": "body1",
            "placeholder": "body1",
            "counter": "body2",
            "label": "body2"
          }
        }
      },
      "placeholder": {
        "subtitleMaxLength": 120,
        "subtitleMaxLines": 5,
        "titleMaxLength": 65,
        "titleMaxLines": 7,
        "maxWidth": 480,
        "minWidth": 200,
        "spacing": {
          "paddingHMinPc": 15,
          "paddingHMinPx": 24,
          "contentHorizontalPadding": 24,
          "buttonPaddingBottom": 40,
          "subtitlePaddingBottom": 32,
          "titlePaddingBottom": 8,
          "iconPaddingBottom": 16
        }
      },
      "popup": {
        "size": {
          "s": {
            "minWidth": 200,
            "width": 480,
            "minHeight": 240,
            "maxHeight": 479
          },
          "m": {
            "minWidth": 480,
            "width": 720,
            "minHeight": 480,
            "maxHeightVh": 90
          }
        },
        "spacing": {
          "actionsTopMargin": 32,
          "subtitleTopMargin": 8,
          "titleBottomMargin": 24,
          "closeOffset": 8,
          "margin": 32
        }
      },
      "radio": {
        "borderRadius": 50,
        "size": {
          "m": 24,
          "s": 20,
          "content": {
            "m": 8,
            "s": 6
          }
        },
        "typography": {
          "m": "body2",
          "s": "body1"
        }
      },
      "scroll": {
        "size": {
          "m": 6
        },
        "spacing": {
          "sidePadding": 6
        }
      }
    },
    "light": {
      "color": {
        "brand": {
          // 'disableText': '#FFFFFF33',
          // 'disable': '#FFFFFF0D',
          "press": "#FFFFFF1A",
          "hover": "#FFFFFF33",
          "transparent": "#FFFFFF1A",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "successBackground": "#2FC063",
          "successContent": "#46D27A",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "accent": "#FAFCFF",
          "additional": "#68A2FF",
          "lowContrast": "#99C0FF",
          "contrast": "#FAFCFF",
          "dark": "#0044B2",
          "light": "#68A2FF",
          "main": "#0062FF"
        },
        "blueElevation1": {
          // 'disableText': '#FFFFFF33',
          // 'disable': '#FFFFFF0D',
          "status5": "#E590AE",
          "status4": "#C8B4F6",
          "status3": "#75E7FC",
          "status2": "#BEFC58",
          "status1": "#F4BB8C",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "transparent": "#FFFFFF0D",
          "accent": "#CCDFFF",
          "additional": "#99C0FF",
          "lowContrast": "#E5EFFF",
          "contrast": "#FAFCFF",
          "main": "#0062FF"
        },
        "blueElevation2": {
          "disableText": "#FFFFFF33",
          "disable": "#FFFFFF0D",
          "status5": "#E590AE",
          "status4": "#C8B4F6",
          "status3": "#75E7FC",
          "status2": "#BEFC58",
          "status1": "#F4BB8C",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "accent": "#CCDFFF",
          "additional": "#99C0FF",
          "lowContrast": "#E5EFFF",
          "contrast": "#FAFCFF",
          "main": "#277BFF"
        },
        "onBrand": {
          "press": "#FFFFFF1A",
          "hover": "#FFFFFF33",
          "disableText": "#FFFFFF33",
          "disable": "#1113140D",
          "transparent": "#FFFFFF1A",
          "accent": "#3381FF",
          "additional": "#666A73",
          "lowContrast": "#8F909E",
          "contrast": "#202124",
          "main": "#EBEDF0"
        },
        "elevation0": {
          "dark": "#EBEDF0",
          "light": "#FAFCFF",
          "main": "#FAFCFF"
        },
        "elevation1": {
          "dark": "#EBEDF0",
          "light": "#FAFCFF",
          "main": "#F5F7F9"
        },
        "elevation2": {
          "dark": "#D6DBE4",
          "light": "#F5F7F9",
          "main": "#EBEDF0"
        },
        "elevation3": {
          "main": "#D6DBE4"
        },
        "elevationObject": {
          "main": "#FAFCFF"
        },
        "transparent5": {
          "main": "#1113140D"
        },
        "staticBlack80": {
          "main": "#111314CC"
        },
        "staticBlack60": {
          "main": "#11131499"
        },
        "lines": {
          "borderAccent": "#68A2FF",
          "border": "#D6DBE4",
          "dividerBright": "#11131433",
          "divider": "#1113140D"
        },
        "static": {
          "darkLowContrast": "#11131433",
          "dark": "#202124",
          "lightLowContrast": "#FFFFFF33",
          "light": "#FAFCFF"
        },
        "common": {
          "status5Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#D9477C",
          "status4Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#9A64F7",
          "status3Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#00ACC2",
          "status2Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#65A400",
          "status1Contrast": "#FAFCFF",
          "status1Background": "#FF7008",
          "status1Content": "#FF7008",
          "infoContrast": "#FAFCFF",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "errorContrast": "#FAFCFF",
          "errorBackground": "#F94C4C",
          "errorContent": "#F94C4C",
          "warningContrast": "#111314",
          "warningBackground": "#FDD868",
          "warningContent": "#FDA502",
          "successContrast": "#FAFCFF",
          "successBackground": "#2FC063",
          "successContent": "#28A455",
          "disableText": "#11131433",
          "disable": "#1113140D",
          "transparent": "#1113140D",
          "focus": "#1113141A",
          "press": "#1113140D",
          "hover": "#1113141A",
          "lowAccent": "#11131433",
          "accent": "#3381FF",
          "additional": "#A9B0BC",
          "lowContrast": "#8F909E",
          "contrast": "#202124"
        },
        "gradients": {
          "mars": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#360E44",
              "2": "#BA3C71",
              "3": "#FFA37B"
            }
          },
          "venus": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#170035",
              "2": "#541CB0",
              "3": "#D3A8FF"
            }
          },
          "neptune": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#000E57",
              "2": "#0087B4",
              "3": "#2CFFA7"
            }
          },
          "mercury": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#B81F56",
              "2": "#E07B32",
              "3": "#EDDC82"
            }
          },
          "earth": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#0D3325",
              "2": "#389864",
              "3": "#D8FF68"
            }
          },
          "uranus": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#000744",
              "2": "#4A54B2",
              "3": "#C3E2FE"
            }
          },
          "jupiter": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#330033",
              "2": "#8D008D",
              "3": "#FFF435"
            }
          },
          "moon": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#161E21",
              "2": "#516573",
              "3": "#EAEAEA"
            }
          },
          "saturn": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#000F2B",
              "2": "#2B778E",
              "3": "#FFFCA8"
            }
          },
          "pluto": {
            "size": 141.4199981689453,
            "top": 100,
            "left": 100,
            "type": "radial-gradient",
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "color": {
              "1": "#0D2700",
              "2": "#B17C16",
              "3": "#FFE5A2"
            }
          }
        },
        "success": {
          "contrast": "#FAFCFF",
          "dark": "#23904B",
          "light": "#84E1A6",
          "main": "#2FC063",
          "mainContent": "#28A455"
        },
        "warning": {
          "contrast": "#111314",
          "dark": "#F79008",
          "light": "#FDD868",
          "main": "#FDD868",
          "mainContent": "#FDA502"
        },
        "error": {
          "contrast": "#FAFCFF",
          "dark": "#F60909",
          "light": "#FA7979",
          "main": "#F94C4C",
          "mainContent": "#F94C4C"
        },
        "info": {
          "contrast": "#FAFCFF",
          "dark": "#0062FF",
          "light": "#68A2FF",
          "main": "#3381FF",
          "mainContent": "#3381FF"
        },
        "status1": {
          "contrast": "#FAFCFF",
          "dark": "#DC5D00",
          "light": "#FC9549",
          "main": "#FF7008",
          "mainContent": "#FF7008"
        },
        "status2": {
          "contrast": "#FAFCFF",
          "dark": "#658E29",
          "light": "#9CD340",
          "main": "#65A400",
          "mainContent": "#65A400"
        },
        "status3": {
          "contrast": "#FAFCFF",
          "dark": "#4295A7",
          "light": "#53DBED",
          "main": "#00ACC2",
          "mainContent": "#00ACC2"
        },
        "status4": {
          "contrast": "#FAFCFF",
          "dark": "#7646EC",
          "light": "#B996F5",
          "main": "#9A64F7",
          "mainContent": "#9A64F7"
        },
        "status5": {
          "contrast": "#FAFCFF",
          "dark": "#C03D67",
          "light": "#F179A4",
          "main": "#D9477C",
          "mainContent": "#D9477C"
        },
        "dionCommon": {
          "status5Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#D9477C",
          "status4Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#9A64F7",
          "status3Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#00ACC2",
          "status2Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#65A400",
          "status1Contrast": "#FAFCFF",
          "status1Background": "#FF7008",
          "status1Content": "#FF7008",
          "infoContrast": "#FAFCFF",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "errorContrast": "#FAFCFF",
          "errorBackground": "#F94C4C",
          "errorContent": "#F94C4C",
          "warningContrast": "#111314",
          "warningBackground": "#FDD868",
          "warningContent": "#FDA502",
          "successContrast": "#FAFCFF",
          "successBackground": "#2FC063",
          "successContent": "#28A455",
          "disableText": "#11131433",
          "disable": "#1113140D",
          "transparent": "#1113140D",
          "focus": "#1113141A",
          "press": "#1113140D",
          "hover": "#1113141A",
          "lowAccent": "#11131433",
          "accent": "#3381FF",
          "additional": "#A9B0BC",
          "lowContrast": "#8F909E",
          "contrast": "#202124"
        }
      },
      "radius": {
        "xxxxxl": 360,
        "xxl": 32,
        "xl": 24,
        "l": 16,
        "m": 12,
        "s": 8,
        "xs": 6,
        "xxs": 4,
        "none": 0
      },
      "spacing": {
        "general": {
          "xxxxxl": 56,
          "xxxxl": 48,
          "xxxl": 40,
          "xxl": 32,
          "xl": 24,
          "l": 16,
          "m": 12,
          "s": 8,
          "xs": 6,
          "xxs": 4,
          "none": 0
        }
      },
      "avatar": {
        "letterCount": {
          "xxxl": 2,
          "xxl": 2,
          "xl": 2,
          "l": 2,
          "m": 2,
          "s": 2,
          "xs": 1
        },
        "variant": {
          "rounded": {
            "borderRadius": 50
          },
          "square": {
            "borderRadius": 25
          }
        },
        "size": {
          "avatar": {
            "xxxl": 128,
            "xxl": 96,
            "xl": 56,
            "l": 48,
            "m": 40,
            "s": 32,
            "xs": 24
          },
          "icon": {
            "xxxl": "xxxxxl",
            "xxl": "xxxxl",
            "xl": "xl",
            "l": "l",
            "m": "m",
            "s": "s",
            "xs": "xs"
          }
        },
        "typography": {
          "xxxl": "h2",
          "xxl": "h2",
          "xl": "h6",
          "l": "button1",
          "m": "button2",
          "s": "caption1",
          "xs": "caption1"
        },
        "controls": {
          "counter": {
            "size": {
              "xxxl": 24,
              "xxl": 20,
              "xl": 16,
              "l": 16,
              "m": 16,
              "s": 12,
              "xs": 12
            },
            "border": {
              "xxxl": 4,
              "xxl": 3,
              "xl": 2,
              "l": 2,
              "m": 2,
              "s": 2,
              "xs": 2
            },
            "typography": {
              "xxxl": "h5",
              "xxl": "h6",
              "xl": "body2",
              "l": "body2",
              "m": "body2",
              "s": "caption1",
              "xs": "caption2"
            },
            "radius": {
              "xxxl": 32,
              "xxl": 8,
              "xl": 8,
              "l": 8,
              "m": 8,
              "s": 8,
              "xs": 8
            }
          },
          "online": {
            "icon": "Fill",
            "size": {
              "xxxl": 16,
              "xxl": 16,
              "xl": 8,
              "l": 8,
              "m": 6,
              "s": 6,
              "xs": 4
            },
            "border": {
              "xxxl": 4,
              "xxl": 3,
              "xl": 2,
              "l": 2,
              "m": 2,
              "s": 2,
              "xs": 2
            },
            "iconSize": {
              "xxxl": "l",
              "xxl": "m",
              "xl": "xs",
              "l": "xs",
              "m": "xxs",
              "s": "xxs",
              "xs": "xxxs"
            }
          },
          "slot": {
            "size": {
              "xxxl": 44,
              "xxl": 40,
              "xl": 24,
              "l": 20,
              "m": 20,
              "s": 20,
              "xs": 16
            },
            "border": {
              "xxxl": 4,
              "xxl": 3,
              "xl": 2,
              "l": 2,
              "m": 2,
              "s": 2,
              "xs": 2
            },
            "iconSize": {
              "xxxl": "xl",
              "xxl": "l",
              "xl": "s",
              "l": "xs",
              "m": "xs",
              "s": "xs",
              "xs": "xxs"
            }
          },
          "close": {
            "icon": "String value",
            "border": {
              "xxxl": 3,
              "xxl": 3,
              "xl": 2,
              "l": 2,
              "m": 2,
              "s": 2,
              "xs": 2
            },
            "size": {
              "xxxl": 24,
              "xxl": 24,
              "xl": 16,
              "l": 16,
              "m": 16,
              "s": 16,
              "xs": 12
            },
            "iconSize": {
              "xxxl": "l",
              "xxl": "l",
              "xl": "s",
              "l": "s",
              "m": "s",
              "s": "s",
              "xs": "xs"
            }
          }
        }
      },
      "border": {
        "xl": 5,
        "l": 4,
        "m": 3,
        "s": 2,
        "xs": 1
      },
      "button": {
        "spacing": {
          "xl": 24,
          "l": 16,
          "m": 16,
          "s": 12,
          "xs": 8,
          "xxs": 4,
          "xxxs": 4
        },
        "borderRadius": {
          "xl": 12,
          "l": 8,
          "m": 8,
          "s": 8,
          "xs": 6,
          "xxs": 4,
          "xxxs": 4
        },
        "size": {
          "xl": 56,
          "l": 48,
          "m": 40,
          "s": 32,
          "xs": 24,
          "xxs": 20,
          "xxxs": 16,
          "icon": {
            "xl": "l",
            "l": "m",
            "m": "m",
            "s": "s",
            "xs": "s",
            "xxs": "s",
            "xxxs": "xs"
          },
          "typography": {
            "xl": "button1",
            "l": "button1",
            "m": "button1",
            "s": "button2",
            "xs": "button2",
            "xxs": "body2",
            "xxxs": "caption2"
          }
        }
      },
      "buttonGroup": {
        "spacing": {
          "m": 16
        }
      },
      "dialog": {
        "borderRadius": 16
      },
      "drawer": {
        "borderRadius": {
          "top": 16
        },
        "spacing": {
          "actionsBottomMargin": 56,
          "actionsTopMargin": 24,
          "subtitleTopMargin": 24,
          "titleBottomMargin": 24,
          "margin": 24
        }
      },
      "sidePanel": {
        "spacing": {
          "titleMargin": 16,
          "margin": 24,
          "actionsMargin": 24
        }
      },
      "icon": {
        "size": {
          "xxxxxl": 64,
          "xxxxl": 56,
          "xxxl": 48,
          "xxl": 40,
          "xl": 32,
          "l": 24,
          "m": 20,
          "s": 16,
          "xs": 12,
          "xxs": 10,
          "xxxs": 8,
          "xxxxs": 6,
          "xxxxxs": 4
        }
      },
      "input": {
        "margin": {
          "m": {
            "bottom": 8,
            "top": 8
          },
          "l": {
            "bottom": 8,
            "top": 8
          }
        },
        "padding": {
          "m": {
            "content": 12,
            "icon": 8
          },
          "l": {
            "content": 16,
            "icon": 12
          }
        },
        "borderRadius": {
          "l": 8,
          "m": 8
        },
        "size": {
          "l": 48,
          "m": 40
        },
        "typography": {
          "m": {
            "additional": "caption1",
            "mainText": "body1",
            "placeholder": "body1",
            "counter": "body2",
            "label": "body2"
          },
          "l": {
            "additional": "caption1",
            "mainText": "body1",
            "placeholder": "body1",
            "counter": "body2",
            "label": "body2"
          }
        }
      },
      "placeholder": {
        "subtitleMaxLength": 120,
        "subtitleMaxLines": 5,
        "titleMaxLength": 65,
        "titleMaxLines": 7,
        "maxWidth": 480,
        "minWidth": 200,
        "spacing": {
          "paddingHMinPc": 15,
          "paddingHMinPx": 24,
          "contentHorizontalPadding": 24,
          "buttonPaddingBottom": 40,
          "subtitlePaddingBottom": 32,
          "titlePaddingBottom": 8,
          "iconPaddingBottom": 16
        }
      },
      "popup": {
        "size": {
          "s": {
            "minWidth": 200,
            "width": 480,
            "minHeight": 320,
            "maxHeight": 479
          },
          "m": {
            "minWidth": 480,
            "width": 720,
            "minHeight": 480,
            "maxHeightVh": 90
          }
        },
        "spacing": {
          "actionsTopMargin": 32,
          "subtitleTopMargin": 8,
          "titleBottomMargin": 24,
          "closeOffset": 8,
          "margin": 32
        }
      },
      "radio": {
        "borderRadius": 50,
        "size": {
          "m": 24,
          "s": 20,
          "content": {
            "m": 8,
            "s": 6
          }
        },
        "typography": {
          "m": "body2",
          "s": "body1"
        }
      },
      "scroll": {
        "size": {
          "m": 6
        },
        "spacing": {
          "sidePadding": 6
        }
      }
    }
  },
  "typography": {
    "h6": {
      "fontFamily": "VTB Group UI",
      "fontSize": "18px",
      "fontWeight": 500,
      "lineHeight": "22px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "h5": {
      "fontFamily": "VTB Group UI",
      "fontSize": "20px",
      "fontWeight": 500,
      "lineHeight": "24px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "h4": {
      "fontFamily": "VTB Group UI",
      "fontSize": "24px",
      "fontWeight": 500,
      "lineHeight": "30px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "h3": {
      "fontFamily": "VTB Group UI",
      "fontSize": "28px",
      "fontWeight": 500,
      "lineHeight": "34px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "h2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "32px",
      "fontWeight": 400,
      "lineHeight": "36px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "h1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "60px",
      "fontWeight": 400,
      "lineHeight": "70px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "subtitle3": {
      "fontFamily": "VTB Group UI",
      "fontSize": "14px",
      "fontWeight": 500,
      "lineHeight": "18px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "subtitle2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "16px",
      "fontWeight": 500,
      "lineHeight": "22px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "subtitle1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "18px",
      "fontWeight": 400,
      "lineHeight": "22px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "body2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "14px",
      "fontWeight": 400,
      "lineHeight": "18px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "body2Short": {
      "fontFamily": "VTB Group UI",
      "fontSize": "14px",
      "fontWeight": 400,
      "lineHeight": "14px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "body1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "16px",
      "fontWeight": 400,
      "lineHeight": "22px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "body1Short": {
      "fontFamily": "VTB Group UI",
      "fontSize": "16px",
      "fontWeight": 400,
      "lineHeight": "18px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "button2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "14px",
      "fontWeight": 500,
      "lineHeight": "18px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "button1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "16px",
      "fontWeight": 500,
      "lineHeight": "18px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "caption2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "10px",
      "fontWeight": 400,
      "lineHeight": "12px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "caption1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "12px",
      "fontWeight": 400,
      "lineHeight": "14px",
      "letterSpacing": "0%",
      "textTransform": "none",
      "textDecoration": "NONE"
    },
    "caption1Caps": {
      "fontFamily": "VTB Group UI",
      "fontSize": "12px",
      "fontWeight": 400,
      "lineHeight": "14px",
      "letterSpacing": "0%",
      "textTransform": "uppercase",
      "textDecoration": "NONE"
    }
  }
};
var EThemeGradients = /* @__PURE__ */ ((EThemeGradients2) => {
  EThemeGradients2["NONE"] = "none";
  EThemeGradients2["MARS"] = "mars";
  EThemeGradients2["VENUS"] = "venus";
  EThemeGradients2["NEPTUNE"] = "neptune";
  EThemeGradients2["MERCURY"] = "mercury";
  EThemeGradients2["EARTH"] = "earth";
  EThemeGradients2["URANUS"] = "uranus";
  EThemeGradients2["JUPITER"] = "jupiter";
  EThemeGradients2["MOON"] = "moon";
  EThemeGradients2["SATURN"] = "saturn";
  EThemeGradients2["PLUTO"] = "pluto";
  return EThemeGradients2;
})(EThemeGradients || {});
var EDionColorGroups = /* @__PURE__ */ ((EDionColorGroups2) => {
  EDionColorGroups2["brand"] = "brand";
  EDionColorGroups2["blueElevation1"] = "blueElevation1";
  EDionColorGroups2["blueElevation2"] = "blueElevation2";
  EDionColorGroups2["onBrand"] = "onBrand";
  EDionColorGroups2["elevation0"] = "elevation0";
  EDionColorGroups2["elevation1"] = "elevation1";
  EDionColorGroups2["elevation2"] = "elevation2";
  EDionColorGroups2["elevation3"] = "elevation3";
  EDionColorGroups2["elevationObject"] = "elevationObject";
  EDionColorGroups2["transparent5"] = "transparent5";
  EDionColorGroups2["staticBlack80"] = "staticBlack80";
  EDionColorGroups2["staticBlack60"] = "staticBlack60";
  EDionColorGroups2["success"] = "success";
  EDionColorGroups2["warning"] = "warning";
  EDionColorGroups2["error"] = "error";
  EDionColorGroups2["info"] = "info";
  EDionColorGroups2["status1"] = "status1";
  EDionColorGroups2["status2"] = "status2";
  EDionColorGroups2["status3"] = "status3";
  EDionColorGroups2["status4"] = "status4";
  EDionColorGroups2["status5"] = "status5";
  return EDionColorGroups2;
})(EDionColorGroups || {});
var EDionColorNames = /* @__PURE__ */ ((EDionColorNames2) => {
  EDionColorNames2["status5Contrast"] = "status5Contrast";
  EDionColorNames2["status5Background"] = "status5Background";
  EDionColorNames2["status5Content"] = "status5Content";
  EDionColorNames2["status4Contrast"] = "status4Contrast";
  EDionColorNames2["status4Background"] = "status4Background";
  EDionColorNames2["status4Content"] = "status4Content";
  EDionColorNames2["status3Contrast"] = "status3Contrast";
  EDionColorNames2["status3Background"] = "status3Background";
  EDionColorNames2["status3Content"] = "status3Content";
  EDionColorNames2["status2Contrast"] = "status2Contrast";
  EDionColorNames2["status2Background"] = "status2Background";
  EDionColorNames2["status2Content"] = "status2Content";
  EDionColorNames2["status1Contrast"] = "status1Contrast";
  EDionColorNames2["status1Background"] = "status1Background";
  EDionColorNames2["status1Content"] = "status1Content";
  EDionColorNames2["infoContrast"] = "infoContrast";
  EDionColorNames2["infoBackground"] = "infoBackground";
  EDionColorNames2["infoContent"] = "infoContent";
  EDionColorNames2["errorContrast"] = "errorContrast";
  EDionColorNames2["errorBackground"] = "errorBackground";
  EDionColorNames2["errorContent"] = "errorContent";
  EDionColorNames2["warningContrast"] = "warningContrast";
  EDionColorNames2["warningBackground"] = "warningBackground";
  EDionColorNames2["warningContent"] = "warningContent";
  EDionColorNames2["successContrast"] = "successContrast";
  EDionColorNames2["successBackground"] = "successBackground";
  EDionColorNames2["successContent"] = "successContent";
  EDionColorNames2["disableText"] = "disableText";
  EDionColorNames2["disable"] = "disable";
  EDionColorNames2["transparent"] = "transparent";
  EDionColorNames2["focus"] = "focus";
  EDionColorNames2["press"] = "press";
  EDionColorNames2["hover"] = "hover";
  EDionColorNames2["lowAccent"] = "lowAccent";
  EDionColorNames2["accent"] = "accent";
  EDionColorNames2["additional"] = "additional";
  EDionColorNames2["lowContrast"] = "lowContrast";
  EDionColorNames2["contrast"] = "contrast";
  EDionColorNames2["main"] = "main";
  return EDionColorNames2;
})(EDionColorNames || {});
var EDionColors = /* @__PURE__ */ ((EDionColors2) => {
  EDionColors2["BRAND_STATUS_5_CONTRAST"] = "brand.status5Contrast";
  EDionColors2["BRAND_STATUS_5_BACKGROUND"] = "brand.status5Background";
  EDionColors2["BRAND_STATUS_5_CONTENT"] = "brand.status5Content";
  EDionColors2["BRAND_STATUS_4_CONTRAST"] = "brand.status4Contrast";
  EDionColors2["BRAND_STATUS_4_BACKGROUND"] = "brand.status4Background";
  EDionColors2["BRAND_STATUS_4_CONTENT"] = "brand.status4Content";
  EDionColors2["BRAND_STATUS_3_CONTRAST"] = "brand.status3Contrast";
  EDionColors2["BRAND_STATUS_3_BACKGROUND"] = "brand.status3Background";
  EDionColors2["BRAND_STATUS_3_CONTENT"] = "brand.status3Content";
  EDionColors2["BRAND_STATUS_2_CONTRAST"] = "brand.status2Contrast";
  EDionColors2["BRAND_STATUS_2_BACKGROUND"] = "brand.status2Background";
  EDionColors2["BRAND_STATUS_2_CONTENT"] = "brand.status2Content";
  EDionColors2["BRAND_STATUS_1_CONTRAST"] = "brand.status1Contrast";
  EDionColors2["BRAND_STATUS_1_BACKGROUND"] = "brand.status1Background";
  EDionColors2["BRAND_STATUS_1_CONTENT"] = "brand.status1Content";
  EDionColors2["BRAND_INFO_CONTRAST"] = "brand.infoContrast";
  EDionColors2["BRAND_INFO_BACKGROUND"] = "brand.infoBackground";
  EDionColors2["BRAND_INFO_CONTENT"] = "brand.infoContent";
  EDionColors2["BRAND_ERROR_CONTRAST"] = "brand.errorContrast";
  EDionColors2["BRAND_ERROR_BACKGROUND"] = "brand.errorBackground";
  EDionColors2["BRAND_ERROR_CONTENT"] = "brand.errorContent";
  EDionColors2["BRAND_WARNING_CONTRAST"] = "brand.warningContrast";
  EDionColors2["BRAND_WARNING_BACKGROUND"] = "brand.warningBackground";
  EDionColors2["BRAND_WARNING_CONTENT"] = "brand.warningContent";
  EDionColors2["BRAND_SUCCESS_CONTRAST"] = "brand.successContrast";
  EDionColors2["BRAND_SUCCESS_BACKGROUND"] = "brand.successBackground";
  EDionColors2["BRAND_SUCCESS_CONTENT"] = "brand.successContent";
  EDionColors2["BRAND_DISABLE_TEXT"] = "brand.disableText";
  EDionColors2["BRAND_DISABLE"] = "brand.disable";
  EDionColors2["BRAND_TRANSPARENT"] = "brand.transparent";
  EDionColors2["BRAND_FOCUS"] = "brand.focus";
  EDionColors2["BRAND_PRESS"] = "brand.press";
  EDionColors2["BRAND_HOVER"] = "brand.hover";
  EDionColors2["BRAND_LOW_ACCENT"] = "brand.lowAccent";
  EDionColors2["BRAND_ACCENT"] = "brand.accent";
  EDionColors2["BRAND_ADDITIONAL"] = "brand.additional";
  EDionColors2["BRAND_LOW_CONTRAST"] = "brand.lowContrast";
  EDionColors2["BRAND_CONTRAST"] = "brand.contrast";
  EDionColors2["BRAND_MAIN"] = "brand.main";
  EDionColors2["BLUE_ELEVATION_1_STATUS_5_CONTRAST"] = "blueElevation1.status5Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_5_BACKGROUND"] = "blueElevation1.status5Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_5_CONTENT"] = "blueElevation1.status5Content";
  EDionColors2["BLUE_ELEVATION_1_STATUS_4_CONTRAST"] = "blueElevation1.status4Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_4_BACKGROUND"] = "blueElevation1.status4Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_4_CONTENT"] = "blueElevation1.status4Content";
  EDionColors2["BLUE_ELEVATION_1_STATUS_3_CONTRAST"] = "blueElevation1.status3Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_3_BACKGROUND"] = "blueElevation1.status3Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_3_CONTENT"] = "blueElevation1.status3Content";
  EDionColors2["BLUE_ELEVATION_1_STATUS_2_CONTRAST"] = "blueElevation1.status2Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_2_BACKGROUND"] = "blueElevation1.status2Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_2_CONTENT"] = "blueElevation1.status2Content";
  EDionColors2["BLUE_ELEVATION_1_STATUS_1_CONTRAST"] = "blueElevation1.status1Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_1_BACKGROUND"] = "blueElevation1.status1Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_1_CONTENT"] = "blueElevation1.status1Content";
  EDionColors2["BLUE_ELEVATION_1_INFO_CONTRAST"] = "blueElevation1.infoContrast";
  EDionColors2["BLUE_ELEVATION_1_INFO_BACKGROUND"] = "blueElevation1.infoBackground";
  EDionColors2["BLUE_ELEVATION_1_INFO_CONTENT"] = "blueElevation1.infoContent";
  EDionColors2["BLUE_ELEVATION_1_ERROR_CONTRAST"] = "blueElevation1.errorContrast";
  EDionColors2["BLUE_ELEVATION_1_ERROR_BACKGROUND"] = "blueElevation1.errorBackground";
  EDionColors2["BLUE_ELEVATION_1_ERROR_CONTENT"] = "blueElevation1.errorContent";
  EDionColors2["BLUE_ELEVATION_1_WARNING_CONTRAST"] = "blueElevation1.warningContrast";
  EDionColors2["BLUE_ELEVATION_1_WARNING_BACKGROUND"] = "blueElevation1.warningBackground";
  EDionColors2["BLUE_ELEVATION_1_WARNING_CONTENT"] = "blueElevation1.warningContent";
  EDionColors2["BLUE_ELEVATION_1_SUCCESS_CONTRAST"] = "blueElevation1.successContrast";
  EDionColors2["BLUE_ELEVATION_1_SUCCESS_BACKGROUND"] = "blueElevation1.successBackground";
  EDionColors2["BLUE_ELEVATION_1_SUCCESS_CONTENT"] = "blueElevation1.successContent";
  EDionColors2["BLUE_ELEVATION_1_DISABLE_TEXT"] = "blueElevation1.disableText";
  EDionColors2["BLUE_ELEVATION_1_DISABLE"] = "blueElevation1.disable";
  EDionColors2["BLUE_ELEVATION_1_TRANSPARENT"] = "blueElevation1.transparent";
  EDionColors2["BLUE_ELEVATION_1_FOCUS"] = "blueElevation1.focus";
  EDionColors2["BLUE_ELEVATION_1_PRESS"] = "blueElevation1.press";
  EDionColors2["BLUE_ELEVATION_1_HOVER"] = "blueElevation1.hover";
  EDionColors2["BLUE_ELEVATION_1_LOW_ACCENT"] = "blueElevation1.lowAccent";
  EDionColors2["BLUE_ELEVATION_1_ACCENT"] = "blueElevation1.accent";
  EDionColors2["BLUE_ELEVATION_1_ADDITIONAL"] = "blueElevation1.additional";
  EDionColors2["BLUE_ELEVATION_1_LOW_CONTRAST"] = "blueElevation1.lowContrast";
  EDionColors2["BLUE_ELEVATION_1_CONTRAST"] = "blueElevation1.contrast";
  EDionColors2["BLUE_ELEVATION_1_MAIN"] = "blueElevation1.main";
  EDionColors2["BLUE_ELEVATION_2_STATUS_5_CONTRAST"] = "blueElevation2.status5Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_5_BACKGROUND"] = "blueElevation2.status5Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_5_CONTENT"] = "blueElevation2.status5Content";
  EDionColors2["BLUE_ELEVATION_2_STATUS_4_CONTRAST"] = "blueElevation2.status4Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_4_BACKGROUND"] = "blueElevation2.status4Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_4_CONTENT"] = "blueElevation2.status4Content";
  EDionColors2["BLUE_ELEVATION_2_STATUS_3_CONTRAST"] = "blueElevation2.status3Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_3_BACKGROUND"] = "blueElevation2.status3Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_3_CONTENT"] = "blueElevation2.status3Content";
  EDionColors2["BLUE_ELEVATION_2_STATUS_2_CONTRAST"] = "blueElevation2.status2Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_2_BACKGROUND"] = "blueElevation2.status2Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_2_CONTENT"] = "blueElevation2.status2Content";
  EDionColors2["BLUE_ELEVATION_2_STATUS_1_CONTRAST"] = "blueElevation2.status1Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_1_BACKGROUND"] = "blueElevation2.status1Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_1_CONTENT"] = "blueElevation2.status1Content";
  EDionColors2["BLUE_ELEVATION_2_INFO_CONTRAST"] = "blueElevation2.infoContrast";
  EDionColors2["BLUE_ELEVATION_2_INFO_BACKGROUND"] = "blueElevation2.infoBackground";
  EDionColors2["BLUE_ELEVATION_2_INFO_CONTENT"] = "blueElevation2.infoContent";
  EDionColors2["BLUE_ELEVATION_2_ERROR_CONTRAST"] = "blueElevation2.errorContrast";
  EDionColors2["BLUE_ELEVATION_2_ERROR_BACKGROUND"] = "blueElevation2.errorBackground";
  EDionColors2["BLUE_ELEVATION_2_ERROR_CONTENT"] = "blueElevation2.errorContent";
  EDionColors2["BLUE_ELEVATION_2_WARNING_CONTRAST"] = "blueElevation2.warningContrast";
  EDionColors2["BLUE_ELEVATION_2_WARNING_BACKGROUND"] = "blueElevation2.warningBackground";
  EDionColors2["BLUE_ELEVATION_2_WARNING_CONTENT"] = "blueElevation2.warningContent";
  EDionColors2["BLUE_ELEVATION_2_SUCCESS_CONTRAST"] = "blueElevation2.successContrast";
  EDionColors2["BLUE_ELEVATION_2_SUCCESS_BACKGROUND"] = "blueElevation2.successBackground";
  EDionColors2["BLUE_ELEVATION_2_SUCCESS_CONTENT"] = "blueElevation2.successContent";
  EDionColors2["BLUE_ELEVATION_2_DISABLE_TEXT"] = "blueElevation2.disableText";
  EDionColors2["BLUE_ELEVATION_2_DISABLE"] = "blueElevation2.disable";
  EDionColors2["BLUE_ELEVATION_2_TRANSPARENT"] = "blueElevation2.transparent";
  EDionColors2["BLUE_ELEVATION_2_FOCUS"] = "blueElevation2.focus";
  EDionColors2["BLUE_ELEVATION_2_PRESS"] = "blueElevation2.press";
  EDionColors2["BLUE_ELEVATION_2_HOVER"] = "blueElevation2.hover";
  EDionColors2["BLUE_ELEVATION_2_LOW_ACCENT"] = "blueElevation2.lowAccent";
  EDionColors2["BLUE_ELEVATION_2_ACCENT"] = "blueElevation2.accent";
  EDionColors2["BLUE_ELEVATION_2_ADDITIONAL"] = "blueElevation2.additional";
  EDionColors2["BLUE_ELEVATION_2_LOW_CONTRAST"] = "blueElevation2.lowContrast";
  EDionColors2["BLUE_ELEVATION_2_CONTRAST"] = "blueElevation2.contrast";
  EDionColors2["BLUE_ELEVATION_2_MAIN"] = "blueElevation2.main";
  EDionColors2["ON_BRAND_STATUS_5_CONTRAST"] = "onBrand.status5Contrast";
  EDionColors2["ON_BRAND_STATUS_5_BACKGROUND"] = "onBrand.status5Background";
  EDionColors2["ON_BRAND_STATUS_5_CONTENT"] = "onBrand.status5Content";
  EDionColors2["ON_BRAND_STATUS_4_CONTRAST"] = "onBrand.status4Contrast";
  EDionColors2["ON_BRAND_STATUS_4_BACKGROUND"] = "onBrand.status4Background";
  EDionColors2["ON_BRAND_STATUS_4_CONTENT"] = "onBrand.status4Content";
  EDionColors2["ON_BRAND_STATUS_3_CONTRAST"] = "onBrand.status3Contrast";
  EDionColors2["ON_BRAND_STATUS_3_BACKGROUND"] = "onBrand.status3Background";
  EDionColors2["ON_BRAND_STATUS_3_CONTENT"] = "onBrand.status3Content";
  EDionColors2["ON_BRAND_STATUS_2_CONTRAST"] = "onBrand.status2Contrast";
  EDionColors2["ON_BRAND_STATUS_2_BACKGROUND"] = "onBrand.status2Background";
  EDionColors2["ON_BRAND_STATUS_2_CONTENT"] = "onBrand.status2Content";
  EDionColors2["ON_BRAND_STATUS_1_CONTRAST"] = "onBrand.status1Contrast";
  EDionColors2["ON_BRAND_STATUS_1_BACKGROUND"] = "onBrand.status1Background";
  EDionColors2["ON_BRAND_STATUS_1_CONTENT"] = "onBrand.status1Content";
  EDionColors2["ON_BRAND_INFO_CONTRAST"] = "onBrand.infoContrast";
  EDionColors2["ON_BRAND_INFO_BACKGROUND"] = "onBrand.infoBackground";
  EDionColors2["ON_BRAND_INFO_CONTENT"] = "onBrand.infoContent";
  EDionColors2["ON_BRAND_ERROR_CONTRAST"] = "onBrand.errorContrast";
  EDionColors2["ON_BRAND_ERROR_BACKGROUND"] = "onBrand.errorBackground";
  EDionColors2["ON_BRAND_ERROR_CONTENT"] = "onBrand.errorContent";
  EDionColors2["ON_BRAND_WARNING_CONTRAST"] = "onBrand.warningContrast";
  EDionColors2["ON_BRAND_WARNING_BACKGROUND"] = "onBrand.warningBackground";
  EDionColors2["ON_BRAND_WARNING_CONTENT"] = "onBrand.warningContent";
  EDionColors2["ON_BRAND_SUCCESS_CONTRAST"] = "onBrand.successContrast";
  EDionColors2["ON_BRAND_SUCCESS_BACKGROUND"] = "onBrand.successBackground";
  EDionColors2["ON_BRAND_SUCCESS_CONTENT"] = "onBrand.successContent";
  EDionColors2["ON_BRAND_DISABLE_TEXT"] = "onBrand.disableText";
  EDionColors2["ON_BRAND_DISABLE"] = "onBrand.disable";
  EDionColors2["ON_BRAND_TRANSPARENT"] = "onBrand.transparent";
  EDionColors2["ON_BRAND_FOCUS"] = "onBrand.focus";
  EDionColors2["ON_BRAND_PRESS"] = "onBrand.press";
  EDionColors2["ON_BRAND_HOVER"] = "onBrand.hover";
  EDionColors2["ON_BRAND_LOW_ACCENT"] = "onBrand.lowAccent";
  EDionColors2["ON_BRAND_ACCENT"] = "onBrand.accent";
  EDionColors2["ON_BRAND_ADDITIONAL"] = "onBrand.additional";
  EDionColors2["ON_BRAND_LOW_CONTRAST"] = "onBrand.lowContrast";
  EDionColors2["ON_BRAND_CONTRAST"] = "onBrand.contrast";
  EDionColors2["ON_BRAND_MAIN"] = "onBrand.main";
  EDionColors2["ELEVATION_0_STATUS_5_CONTRAST"] = "elevation0.status5Contrast";
  EDionColors2["ELEVATION_0_STATUS_5_BACKGROUND"] = "elevation0.status5Background";
  EDionColors2["ELEVATION_0_STATUS_5_CONTENT"] = "elevation0.status5Content";
  EDionColors2["ELEVATION_0_STATUS_4_CONTRAST"] = "elevation0.status4Contrast";
  EDionColors2["ELEVATION_0_STATUS_4_BACKGROUND"] = "elevation0.status4Background";
  EDionColors2["ELEVATION_0_STATUS_4_CONTENT"] = "elevation0.status4Content";
  EDionColors2["ELEVATION_0_STATUS_3_CONTRAST"] = "elevation0.status3Contrast";
  EDionColors2["ELEVATION_0_STATUS_3_BACKGROUND"] = "elevation0.status3Background";
  EDionColors2["ELEVATION_0_STATUS_3_CONTENT"] = "elevation0.status3Content";
  EDionColors2["ELEVATION_0_STATUS_2_CONTRAST"] = "elevation0.status2Contrast";
  EDionColors2["ELEVATION_0_STATUS_2_BACKGROUND"] = "elevation0.status2Background";
  EDionColors2["ELEVATION_0_STATUS_2_CONTENT"] = "elevation0.status2Content";
  EDionColors2["ELEVATION_0_STATUS_1_CONTRAST"] = "elevation0.status1Contrast";
  EDionColors2["ELEVATION_0_STATUS_1_BACKGROUND"] = "elevation0.status1Background";
  EDionColors2["ELEVATION_0_STATUS_1_CONTENT"] = "elevation0.status1Content";
  EDionColors2["ELEVATION_0_INFO_CONTRAST"] = "elevation0.infoContrast";
  EDionColors2["ELEVATION_0_INFO_BACKGROUND"] = "elevation0.infoBackground";
  EDionColors2["ELEVATION_0_INFO_CONTENT"] = "elevation0.infoContent";
  EDionColors2["ELEVATION_0_ERROR_CONTRAST"] = "elevation0.errorContrast";
  EDionColors2["ELEVATION_0_ERROR_BACKGROUND"] = "elevation0.errorBackground";
  EDionColors2["ELEVATION_0_ERROR_CONTENT"] = "elevation0.errorContent";
  EDionColors2["ELEVATION_0_WARNING_CONTRAST"] = "elevation0.warningContrast";
  EDionColors2["ELEVATION_0_WARNING_BACKGROUND"] = "elevation0.warningBackground";
  EDionColors2["ELEVATION_0_WARNING_CONTENT"] = "elevation0.warningContent";
  EDionColors2["ELEVATION_0_SUCCESS_CONTRAST"] = "elevation0.successContrast";
  EDionColors2["ELEVATION_0_SUCCESS_BACKGROUND"] = "elevation0.successBackground";
  EDionColors2["ELEVATION_0_SUCCESS_CONTENT"] = "elevation0.successContent";
  EDionColors2["ELEVATION_0_DISABLE_TEXT"] = "elevation0.disableText";
  EDionColors2["ELEVATION_0_DISABLE"] = "elevation0.disable";
  EDionColors2["ELEVATION_0_TRANSPARENT"] = "elevation0.transparent";
  EDionColors2["ELEVATION_0_FOCUS"] = "elevation0.focus";
  EDionColors2["ELEVATION_0_PRESS"] = "elevation0.press";
  EDionColors2["ELEVATION_0_HOVER"] = "elevation0.hover";
  EDionColors2["ELEVATION_0_LOW_ACCENT"] = "elevation0.lowAccent";
  EDionColors2["ELEVATION_0_ACCENT"] = "elevation0.accent";
  EDionColors2["ELEVATION_0_ADDITIONAL"] = "elevation0.additional";
  EDionColors2["ELEVATION_0_LOW_CONTRAST"] = "elevation0.lowContrast";
  EDionColors2["ELEVATION_0_CONTRAST"] = "elevation0.contrast";
  EDionColors2["ELEVATION_0_MAIN"] = "elevation0.main";
  EDionColors2["ELEVATION_1_STATUS_5_CONTRAST"] = "elevation1.status5Contrast";
  EDionColors2["ELEVATION_1_STATUS_5_BACKGROUND"] = "elevation1.status5Background";
  EDionColors2["ELEVATION_1_STATUS_5_CONTENT"] = "elevation1.status5Content";
  EDionColors2["ELEVATION_1_STATUS_4_CONTRAST"] = "elevation1.status4Contrast";
  EDionColors2["ELEVATION_1_STATUS_4_BACKGROUND"] = "elevation1.status4Background";
  EDionColors2["ELEVATION_1_STATUS_4_CONTENT"] = "elevation1.status4Content";
  EDionColors2["ELEVATION_1_STATUS_3_CONTRAST"] = "elevation1.status3Contrast";
  EDionColors2["ELEVATION_1_STATUS_3_BACKGROUND"] = "elevation1.status3Background";
  EDionColors2["ELEVATION_1_STATUS_3_CONTENT"] = "elevation1.status3Content";
  EDionColors2["ELEVATION_1_STATUS_2_CONTRAST"] = "elevation1.status2Contrast";
  EDionColors2["ELEVATION_1_STATUS_2_BACKGROUND"] = "elevation1.status2Background";
  EDionColors2["ELEVATION_1_STATUS_2_CONTENT"] = "elevation1.status2Content";
  EDionColors2["ELEVATION_1_STATUS_1_CONTRAST"] = "elevation1.status1Contrast";
  EDionColors2["ELEVATION_1_STATUS_1_BACKGROUND"] = "elevation1.status1Background";
  EDionColors2["ELEVATION_1_STATUS_1_CONTENT"] = "elevation1.status1Content";
  EDionColors2["ELEVATION_1_INFO_CONTRAST"] = "elevation1.infoContrast";
  EDionColors2["ELEVATION_1_INFO_BACKGROUND"] = "elevation1.infoBackground";
  EDionColors2["ELEVATION_1_INFO_CONTENT"] = "elevation1.infoContent";
  EDionColors2["ELEVATION_1_ERROR_CONTRAST"] = "elevation1.errorContrast";
  EDionColors2["ELEVATION_1_ERROR_BACKGROUND"] = "elevation1.errorBackground";
  EDionColors2["ELEVATION_1_ERROR_CONTENT"] = "elevation1.errorContent";
  EDionColors2["ELEVATION_1_WARNING_CONTRAST"] = "elevation1.warningContrast";
  EDionColors2["ELEVATION_1_WARNING_BACKGROUND"] = "elevation1.warningBackground";
  EDionColors2["ELEVATION_1_WARNING_CONTENT"] = "elevation1.warningContent";
  EDionColors2["ELEVATION_1_SUCCESS_CONTRAST"] = "elevation1.successContrast";
  EDionColors2["ELEVATION_1_SUCCESS_BACKGROUND"] = "elevation1.successBackground";
  EDionColors2["ELEVATION_1_SUCCESS_CONTENT"] = "elevation1.successContent";
  EDionColors2["ELEVATION_1_DISABLE_TEXT"] = "elevation1.disableText";
  EDionColors2["ELEVATION_1_DISABLE"] = "elevation1.disable";
  EDionColors2["ELEVATION_1_TRANSPARENT"] = "elevation1.transparent";
  EDionColors2["ELEVATION_1_FOCUS"] = "elevation1.focus";
  EDionColors2["ELEVATION_1_PRESS"] = "elevation1.press";
  EDionColors2["ELEVATION_1_HOVER"] = "elevation1.hover";
  EDionColors2["ELEVATION_1_LOW_ACCENT"] = "elevation1.lowAccent";
  EDionColors2["ELEVATION_1_ACCENT"] = "elevation1.accent";
  EDionColors2["ELEVATION_1_ADDITIONAL"] = "elevation1.additional";
  EDionColors2["ELEVATION_1_LOW_CONTRAST"] = "elevation1.lowContrast";
  EDionColors2["ELEVATION_1_CONTRAST"] = "elevation1.contrast";
  EDionColors2["ELEVATION_1_MAIN"] = "elevation1.main";
  EDionColors2["ELEVATION_2_STATUS_5_CONTRAST"] = "elevation2.status5Contrast";
  EDionColors2["ELEVATION_2_STATUS_5_BACKGROUND"] = "elevation2.status5Background";
  EDionColors2["ELEVATION_2_STATUS_5_CONTENT"] = "elevation2.status5Content";
  EDionColors2["ELEVATION_2_STATUS_4_CONTRAST"] = "elevation2.status4Contrast";
  EDionColors2["ELEVATION_2_STATUS_4_BACKGROUND"] = "elevation2.status4Background";
  EDionColors2["ELEVATION_2_STATUS_4_CONTENT"] = "elevation2.status4Content";
  EDionColors2["ELEVATION_2_STATUS_3_CONTRAST"] = "elevation2.status3Contrast";
  EDionColors2["ELEVATION_2_STATUS_3_BACKGROUND"] = "elevation2.status3Background";
  EDionColors2["ELEVATION_2_STATUS_3_CONTENT"] = "elevation2.status3Content";
  EDionColors2["ELEVATION_2_STATUS_2_CONTRAST"] = "elevation2.status2Contrast";
  EDionColors2["ELEVATION_2_STATUS_2_BACKGROUND"] = "elevation2.status2Background";
  EDionColors2["ELEVATION_2_STATUS_2_CONTENT"] = "elevation2.status2Content";
  EDionColors2["ELEVATION_2_STATUS_1_CONTRAST"] = "elevation2.status1Contrast";
  EDionColors2["ELEVATION_2_STATUS_1_BACKGROUND"] = "elevation2.status1Background";
  EDionColors2["ELEVATION_2_STATUS_1_CONTENT"] = "elevation2.status1Content";
  EDionColors2["ELEVATION_2_INFO_CONTRAST"] = "elevation2.infoContrast";
  EDionColors2["ELEVATION_2_INFO_BACKGROUND"] = "elevation2.infoBackground";
  EDionColors2["ELEVATION_2_INFO_CONTENT"] = "elevation2.infoContent";
  EDionColors2["ELEVATION_2_ERROR_CONTRAST"] = "elevation2.errorContrast";
  EDionColors2["ELEVATION_2_ERROR_BACKGROUND"] = "elevation2.errorBackground";
  EDionColors2["ELEVATION_2_ERROR_CONTENT"] = "elevation2.errorContent";
  EDionColors2["ELEVATION_2_WARNING_CONTRAST"] = "elevation2.warningContrast";
  EDionColors2["ELEVATION_2_WARNING_BACKGROUND"] = "elevation2.warningBackground";
  EDionColors2["ELEVATION_2_WARNING_CONTENT"] = "elevation2.warningContent";
  EDionColors2["ELEVATION_2_SUCCESS_CONTRAST"] = "elevation2.successContrast";
  EDionColors2["ELEVATION_2_SUCCESS_BACKGROUND"] = "elevation2.successBackground";
  EDionColors2["ELEVATION_2_SUCCESS_CONTENT"] = "elevation2.successContent";
  EDionColors2["ELEVATION_2_DISABLE_TEXT"] = "elevation2.disableText";
  EDionColors2["ELEVATION_2_DISABLE"] = "elevation2.disable";
  EDionColors2["ELEVATION_2_TRANSPARENT"] = "elevation2.transparent";
  EDionColors2["ELEVATION_2_FOCUS"] = "elevation2.focus";
  EDionColors2["ELEVATION_2_PRESS"] = "elevation2.press";
  EDionColors2["ELEVATION_2_HOVER"] = "elevation2.hover";
  EDionColors2["ELEVATION_2_LOW_ACCENT"] = "elevation2.lowAccent";
  EDionColors2["ELEVATION_2_ACCENT"] = "elevation2.accent";
  EDionColors2["ELEVATION_2_ADDITIONAL"] = "elevation2.additional";
  EDionColors2["ELEVATION_2_LOW_CONTRAST"] = "elevation2.lowContrast";
  EDionColors2["ELEVATION_2_CONTRAST"] = "elevation2.contrast";
  EDionColors2["ELEVATION_2_MAIN"] = "elevation2.main";
  EDionColors2["ELEVATION_3_STATUS_5_CONTRAST"] = "elevation3.status5Contrast";
  EDionColors2["ELEVATION_3_STATUS_5_BACKGROUND"] = "elevation3.status5Background";
  EDionColors2["ELEVATION_3_STATUS_5_CONTENT"] = "elevation3.status5Content";
  EDionColors2["ELEVATION_3_STATUS_4_CONTRAST"] = "elevation3.status4Contrast";
  EDionColors2["ELEVATION_3_STATUS_4_BACKGROUND"] = "elevation3.status4Background";
  EDionColors2["ELEVATION_3_STATUS_4_CONTENT"] = "elevation3.status4Content";
  EDionColors2["ELEVATION_3_STATUS_3_CONTRAST"] = "elevation3.status3Contrast";
  EDionColors2["ELEVATION_3_STATUS_3_BACKGROUND"] = "elevation3.status3Background";
  EDionColors2["ELEVATION_3_STATUS_3_CONTENT"] = "elevation3.status3Content";
  EDionColors2["ELEVATION_3_STATUS_2_CONTRAST"] = "elevation3.status2Contrast";
  EDionColors2["ELEVATION_3_STATUS_2_BACKGROUND"] = "elevation3.status2Background";
  EDionColors2["ELEVATION_3_STATUS_2_CONTENT"] = "elevation3.status2Content";
  EDionColors2["ELEVATION_3_STATUS_1_CONTRAST"] = "elevation3.status1Contrast";
  EDionColors2["ELEVATION_3_STATUS_1_BACKGROUND"] = "elevation3.status1Background";
  EDionColors2["ELEVATION_3_STATUS_1_CONTENT"] = "elevation3.status1Content";
  EDionColors2["ELEVATION_3_INFO_CONTRAST"] = "elevation3.infoContrast";
  EDionColors2["ELEVATION_3_INFO_BACKGROUND"] = "elevation3.infoBackground";
  EDionColors2["ELEVATION_3_INFO_CONTENT"] = "elevation3.infoContent";
  EDionColors2["ELEVATION_3_ERROR_CONTRAST"] = "elevation3.errorContrast";
  EDionColors2["ELEVATION_3_ERROR_BACKGROUND"] = "elevation3.errorBackground";
  EDionColors2["ELEVATION_3_ERROR_CONTENT"] = "elevation3.errorContent";
  EDionColors2["ELEVATION_3_WARNING_CONTRAST"] = "elevation3.warningContrast";
  EDionColors2["ELEVATION_3_WARNING_BACKGROUND"] = "elevation3.warningBackground";
  EDionColors2["ELEVATION_3_WARNING_CONTENT"] = "elevation3.warningContent";
  EDionColors2["ELEVATION_3_SUCCESS_CONTRAST"] = "elevation3.successContrast";
  EDionColors2["ELEVATION_3_SUCCESS_BACKGROUND"] = "elevation3.successBackground";
  EDionColors2["ELEVATION_3_SUCCESS_CONTENT"] = "elevation3.successContent";
  EDionColors2["ELEVATION_3_DISABLE_TEXT"] = "elevation3.disableText";
  EDionColors2["ELEVATION_3_DISABLE"] = "elevation3.disable";
  EDionColors2["ELEVATION_3_TRANSPARENT"] = "elevation3.transparent";
  EDionColors2["ELEVATION_3_FOCUS"] = "elevation3.focus";
  EDionColors2["ELEVATION_3_PRESS"] = "elevation3.press";
  EDionColors2["ELEVATION_3_HOVER"] = "elevation3.hover";
  EDionColors2["ELEVATION_3_LOW_ACCENT"] = "elevation3.lowAccent";
  EDionColors2["ELEVATION_3_ACCENT"] = "elevation3.accent";
  EDionColors2["ELEVATION_3_ADDITIONAL"] = "elevation3.additional";
  EDionColors2["ELEVATION_3_LOW_CONTRAST"] = "elevation3.lowContrast";
  EDionColors2["ELEVATION_3_CONTRAST"] = "elevation3.contrast";
  EDionColors2["ELEVATION_3_MAIN"] = "elevation3.main";
  EDionColors2["ELEVATION_OBJECT_STATUS_5_CONTRAST"] = "elevationObject.status5Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_5_BACKGROUND"] = "elevationObject.status5Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_5_CONTENT"] = "elevationObject.status5Content";
  EDionColors2["ELEVATION_OBJECT_STATUS_4_CONTRAST"] = "elevationObject.status4Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_4_BACKGROUND"] = "elevationObject.status4Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_4_CONTENT"] = "elevationObject.status4Content";
  EDionColors2["ELEVATION_OBJECT_STATUS_3_CONTRAST"] = "elevationObject.status3Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_3_BACKGROUND"] = "elevationObject.status3Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_3_CONTENT"] = "elevationObject.status3Content";
  EDionColors2["ELEVATION_OBJECT_STATUS_2_CONTRAST"] = "elevationObject.status2Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_2_BACKGROUND"] = "elevationObject.status2Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_2_CONTENT"] = "elevationObject.status2Content";
  EDionColors2["ELEVATION_OBJECT_STATUS_1_CONTRAST"] = "elevationObject.status1Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_1_BACKGROUND"] = "elevationObject.status1Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_1_CONTENT"] = "elevationObject.status1Content";
  EDionColors2["ELEVATION_OBJECT_INFO_CONTRAST"] = "elevationObject.infoContrast";
  EDionColors2["ELEVATION_OBJECT_INFO_BACKGROUND"] = "elevationObject.infoBackground";
  EDionColors2["ELEVATION_OBJECT_INFO_CONTENT"] = "elevationObject.infoContent";
  EDionColors2["ELEVATION_OBJECT_ERROR_CONTRAST"] = "elevationObject.errorContrast";
  EDionColors2["ELEVATION_OBJECT_ERROR_BACKGROUND"] = "elevationObject.errorBackground";
  EDionColors2["ELEVATION_OBJECT_ERROR_CONTENT"] = "elevationObject.errorContent";
  EDionColors2["ELEVATION_OBJECT_WARNING_CONTRAST"] = "elevationObject.warningContrast";
  EDionColors2["ELEVATION_OBJECT_WARNING_BACKGROUND"] = "elevationObject.warningBackground";
  EDionColors2["ELEVATION_OBJECT_WARNING_CONTENT"] = "elevationObject.warningContent";
  EDionColors2["ELEVATION_OBJECT_SUCCESS_CONTRAST"] = "elevationObject.successContrast";
  EDionColors2["ELEVATION_OBJECT_SUCCESS_BACKGROUND"] = "elevationObject.successBackground";
  EDionColors2["ELEVATION_OBJECT_SUCCESS_CONTENT"] = "elevationObject.successContent";
  EDionColors2["ELEVATION_OBJECT_DISABLE_TEXT"] = "elevationObject.disableText";
  EDionColors2["ELEVATION_OBJECT_DISABLE"] = "elevationObject.disable";
  EDionColors2["ELEVATION_OBJECT_TRANSPARENT"] = "elevationObject.transparent";
  EDionColors2["ELEVATION_OBJECT_FOCUS"] = "elevationObject.focus";
  EDionColors2["ELEVATION_OBJECT_PRESS"] = "elevationObject.press";
  EDionColors2["ELEVATION_OBJECT_HOVER"] = "elevationObject.hover";
  EDionColors2["ELEVATION_OBJECT_LOW_ACCENT"] = "elevationObject.lowAccent";
  EDionColors2["ELEVATION_OBJECT_ACCENT"] = "elevationObject.accent";
  EDionColors2["ELEVATION_OBJECT_ADDITIONAL"] = "elevationObject.additional";
  EDionColors2["ELEVATION_OBJECT_LOW_CONTRAST"] = "elevationObject.lowContrast";
  EDionColors2["ELEVATION_OBJECT_CONTRAST"] = "elevationObject.contrast";
  EDionColors2["ELEVATION_OBJECT_MAIN"] = "elevationObject.main";
  EDionColors2["TRANSPARENT_5_STATUS_5_CONTRAST"] = "transparent5.status5Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_5_BACKGROUND"] = "transparent5.status5Background";
  EDionColors2["TRANSPARENT_5_STATUS_5_CONTENT"] = "transparent5.status5Content";
  EDionColors2["TRANSPARENT_5_STATUS_4_CONTRAST"] = "transparent5.status4Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_4_BACKGROUND"] = "transparent5.status4Background";
  EDionColors2["TRANSPARENT_5_STATUS_4_CONTENT"] = "transparent5.status4Content";
  EDionColors2["TRANSPARENT_5_STATUS_3_CONTRAST"] = "transparent5.status3Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_3_BACKGROUND"] = "transparent5.status3Background";
  EDionColors2["TRANSPARENT_5_STATUS_3_CONTENT"] = "transparent5.status3Content";
  EDionColors2["TRANSPARENT_5_STATUS_2_CONTRAST"] = "transparent5.status2Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_2_BACKGROUND"] = "transparent5.status2Background";
  EDionColors2["TRANSPARENT_5_STATUS_2_CONTENT"] = "transparent5.status2Content";
  EDionColors2["TRANSPARENT_5_STATUS_1_CONTRAST"] = "transparent5.status1Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_1_BACKGROUND"] = "transparent5.status1Background";
  EDionColors2["TRANSPARENT_5_STATUS_1_CONTENT"] = "transparent5.status1Content";
  EDionColors2["TRANSPARENT_5_INFO_CONTRAST"] = "transparent5.infoContrast";
  EDionColors2["TRANSPARENT_5_INFO_BACKGROUND"] = "transparent5.infoBackground";
  EDionColors2["TRANSPARENT_5_INFO_CONTENT"] = "transparent5.infoContent";
  EDionColors2["TRANSPARENT_5_ERROR_CONTRAST"] = "transparent5.errorContrast";
  EDionColors2["TRANSPARENT_5_ERROR_BACKGROUND"] = "transparent5.errorBackground";
  EDionColors2["TRANSPARENT_5_ERROR_CONTENT"] = "transparent5.errorContent";
  EDionColors2["TRANSPARENT_5_WARNING_CONTRAST"] = "transparent5.warningContrast";
  EDionColors2["TRANSPARENT_5_WARNING_BACKGROUND"] = "transparent5.warningBackground";
  EDionColors2["TRANSPARENT_5_WARNING_CONTENT"] = "transparent5.warningContent";
  EDionColors2["TRANSPARENT_5_SUCCESS_CONTRAST"] = "transparent5.successContrast";
  EDionColors2["TRANSPARENT_5_SUCCESS_BACKGROUND"] = "transparent5.successBackground";
  EDionColors2["TRANSPARENT_5_SUCCESS_CONTENT"] = "transparent5.successContent";
  EDionColors2["TRANSPARENT_5_DISABLE_TEXT"] = "transparent5.disableText";
  EDionColors2["TRANSPARENT_5_DISABLE"] = "transparent5.disable";
  EDionColors2["TRANSPARENT_5_TRANSPARENT"] = "transparent5.transparent";
  EDionColors2["TRANSPARENT_5_FOCUS"] = "transparent5.focus";
  EDionColors2["TRANSPARENT_5_PRESS"] = "transparent5.press";
  EDionColors2["TRANSPARENT_5_HOVER"] = "transparent5.hover";
  EDionColors2["TRANSPARENT_5_LOW_ACCENT"] = "transparent5.lowAccent";
  EDionColors2["TRANSPARENT_5_ACCENT"] = "transparent5.accent";
  EDionColors2["TRANSPARENT_5_ADDITIONAL"] = "transparent5.additional";
  EDionColors2["TRANSPARENT_5_LOW_CONTRAST"] = "transparent5.lowContrast";
  EDionColors2["TRANSPARENT_5_CONTRAST"] = "transparent5.contrast";
  EDionColors2["TRANSPARENT_5_MAIN"] = "transparent5.main";
  EDionColors2["STATIC_BLACK_80_STATUS_5_CONTRAST"] = "staticBlack80.status5Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_5_BACKGROUND"] = "staticBlack80.status5Background";
  EDionColors2["STATIC_BLACK_80_STATUS_5_CONTENT"] = "staticBlack80.status5Content";
  EDionColors2["STATIC_BLACK_80_STATUS_4_CONTRAST"] = "staticBlack80.status4Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_4_BACKGROUND"] = "staticBlack80.status4Background";
  EDionColors2["STATIC_BLACK_80_STATUS_4_CONTENT"] = "staticBlack80.status4Content";
  EDionColors2["STATIC_BLACK_80_STATUS_3_CONTRAST"] = "staticBlack80.status3Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_3_BACKGROUND"] = "staticBlack80.status3Background";
  EDionColors2["STATIC_BLACK_80_STATUS_3_CONTENT"] = "staticBlack80.status3Content";
  EDionColors2["STATIC_BLACK_80_STATUS_2_CONTRAST"] = "staticBlack80.status2Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_2_BACKGROUND"] = "staticBlack80.status2Background";
  EDionColors2["STATIC_BLACK_80_STATUS_2_CONTENT"] = "staticBlack80.status2Content";
  EDionColors2["STATIC_BLACK_80_STATUS_1_CONTRAST"] = "staticBlack80.status1Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_1_BACKGROUND"] = "staticBlack80.status1Background";
  EDionColors2["STATIC_BLACK_80_STATUS_1_CONTENT"] = "staticBlack80.status1Content";
  EDionColors2["STATIC_BLACK_80_INFO_CONTRAST"] = "staticBlack80.infoContrast";
  EDionColors2["STATIC_BLACK_80_INFO_BACKGROUND"] = "staticBlack80.infoBackground";
  EDionColors2["STATIC_BLACK_80_INFO_CONTENT"] = "staticBlack80.infoContent";
  EDionColors2["STATIC_BLACK_80_ERROR_CONTRAST"] = "staticBlack80.errorContrast";
  EDionColors2["STATIC_BLACK_80_ERROR_BACKGROUND"] = "staticBlack80.errorBackground";
  EDionColors2["STATIC_BLACK_80_ERROR_CONTENT"] = "staticBlack80.errorContent";
  EDionColors2["STATIC_BLACK_80_WARNING_CONTRAST"] = "staticBlack80.warningContrast";
  EDionColors2["STATIC_BLACK_80_WARNING_BACKGROUND"] = "staticBlack80.warningBackground";
  EDionColors2["STATIC_BLACK_80_WARNING_CONTENT"] = "staticBlack80.warningContent";
  EDionColors2["STATIC_BLACK_80_SUCCESS_CONTRAST"] = "staticBlack80.successContrast";
  EDionColors2["STATIC_BLACK_80_SUCCESS_BACKGROUND"] = "staticBlack80.successBackground";
  EDionColors2["STATIC_BLACK_80_SUCCESS_CONTENT"] = "staticBlack80.successContent";
  EDionColors2["STATIC_BLACK_80_DISABLE_TEXT"] = "staticBlack80.disableText";
  EDionColors2["STATIC_BLACK_80_DISABLE"] = "staticBlack80.disable";
  EDionColors2["STATIC_BLACK_80_TRANSPARENT"] = "staticBlack80.transparent";
  EDionColors2["STATIC_BLACK_80_FOCUS"] = "staticBlack80.focus";
  EDionColors2["STATIC_BLACK_80_PRESS"] = "staticBlack80.press";
  EDionColors2["STATIC_BLACK_80_HOVER"] = "staticBlack80.hover";
  EDionColors2["STATIC_BLACK_80_LOW_ACCENT"] = "staticBlack80.lowAccent";
  EDionColors2["STATIC_BLACK_80_ACCENT"] = "staticBlack80.accent";
  EDionColors2["STATIC_BLACK_80_ADDITIONAL"] = "staticBlack80.additional";
  EDionColors2["STATIC_BLACK_80_LOW_CONTRAST"] = "staticBlack80.lowContrast";
  EDionColors2["STATIC_BLACK_80_CONTRAST"] = "staticBlack80.contrast";
  EDionColors2["STATIC_BLACK_80_MAIN"] = "staticBlack80.main";
  EDionColors2["STATIC_BLACK_60_STATUS_5_CONTRAST"] = "staticBlack60.status5Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_5_BACKGROUND"] = "staticBlack60.status5Background";
  EDionColors2["STATIC_BLACK_60_STATUS_5_CONTENT"] = "staticBlack60.status5Content";
  EDionColors2["STATIC_BLACK_60_STATUS_4_CONTRAST"] = "staticBlack60.status4Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_4_BACKGROUND"] = "staticBlack60.status4Background";
  EDionColors2["STATIC_BLACK_60_STATUS_4_CONTENT"] = "staticBlack60.status4Content";
  EDionColors2["STATIC_BLACK_60_STATUS_3_CONTRAST"] = "staticBlack60.status3Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_3_BACKGROUND"] = "staticBlack60.status3Background";
  EDionColors2["STATIC_BLACK_60_STATUS_3_CONTENT"] = "staticBlack60.status3Content";
  EDionColors2["STATIC_BLACK_60_STATUS_2_CONTRAST"] = "staticBlack60.status2Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_2_BACKGROUND"] = "staticBlack60.status2Background";
  EDionColors2["STATIC_BLACK_60_STATUS_2_CONTENT"] = "staticBlack60.status2Content";
  EDionColors2["STATIC_BLACK_60_STATUS_1_CONTRAST"] = "staticBlack60.status1Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_1_BACKGROUND"] = "staticBlack60.status1Background";
  EDionColors2["STATIC_BLACK_60_STATUS_1_CONTENT"] = "staticBlack60.status1Content";
  EDionColors2["STATIC_BLACK_60_INFO_CONTRAST"] = "staticBlack60.infoContrast";
  EDionColors2["STATIC_BLACK_60_INFO_BACKGROUND"] = "staticBlack60.infoBackground";
  EDionColors2["STATIC_BLACK_60_INFO_CONTENT"] = "staticBlack60.infoContent";
  EDionColors2["STATIC_BLACK_60_ERROR_CONTRAST"] = "staticBlack60.errorContrast";
  EDionColors2["STATIC_BLACK_60_ERROR_BACKGROUND"] = "staticBlack60.errorBackground";
  EDionColors2["STATIC_BLACK_60_ERROR_CONTENT"] = "staticBlack60.errorContent";
  EDionColors2["STATIC_BLACK_60_WARNING_CONTRAST"] = "staticBlack60.warningContrast";
  EDionColors2["STATIC_BLACK_60_WARNING_BACKGROUND"] = "staticBlack60.warningBackground";
  EDionColors2["STATIC_BLACK_60_WARNING_CONTENT"] = "staticBlack60.warningContent";
  EDionColors2["STATIC_BLACK_60_SUCCESS_CONTRAST"] = "staticBlack60.successContrast";
  EDionColors2["STATIC_BLACK_60_SUCCESS_BACKGROUND"] = "staticBlack60.successBackground";
  EDionColors2["STATIC_BLACK_60_SUCCESS_CONTENT"] = "staticBlack60.successContent";
  EDionColors2["STATIC_BLACK_60_DISABLE_TEXT"] = "staticBlack60.disableText";
  EDionColors2["STATIC_BLACK_60_DISABLE"] = "staticBlack60.disable";
  EDionColors2["STATIC_BLACK_60_TRANSPARENT"] = "staticBlack60.transparent";
  EDionColors2["STATIC_BLACK_60_FOCUS"] = "staticBlack60.focus";
  EDionColors2["STATIC_BLACK_60_PRESS"] = "staticBlack60.press";
  EDionColors2["STATIC_BLACK_60_HOVER"] = "staticBlack60.hover";
  EDionColors2["STATIC_BLACK_60_LOW_ACCENT"] = "staticBlack60.lowAccent";
  EDionColors2["STATIC_BLACK_60_ACCENT"] = "staticBlack60.accent";
  EDionColors2["STATIC_BLACK_60_ADDITIONAL"] = "staticBlack60.additional";
  EDionColors2["STATIC_BLACK_60_LOW_CONTRAST"] = "staticBlack60.lowContrast";
  EDionColors2["STATIC_BLACK_60_CONTRAST"] = "staticBlack60.contrast";
  EDionColors2["STATIC_BLACK_60_MAIN"] = "staticBlack60.main";
  EDionColors2["SUCCESS_STATUS_5_CONTRAST"] = "success.status5Contrast";
  EDionColors2["SUCCESS_STATUS_5_BACKGROUND"] = "success.status5Background";
  EDionColors2["SUCCESS_STATUS_5_CONTENT"] = "success.status5Content";
  EDionColors2["SUCCESS_STATUS_4_CONTRAST"] = "success.status4Contrast";
  EDionColors2["SUCCESS_STATUS_4_BACKGROUND"] = "success.status4Background";
  EDionColors2["SUCCESS_STATUS_4_CONTENT"] = "success.status4Content";
  EDionColors2["SUCCESS_STATUS_3_CONTRAST"] = "success.status3Contrast";
  EDionColors2["SUCCESS_STATUS_3_BACKGROUND"] = "success.status3Background";
  EDionColors2["SUCCESS_STATUS_3_CONTENT"] = "success.status3Content";
  EDionColors2["SUCCESS_STATUS_2_CONTRAST"] = "success.status2Contrast";
  EDionColors2["SUCCESS_STATUS_2_BACKGROUND"] = "success.status2Background";
  EDionColors2["SUCCESS_STATUS_2_CONTENT"] = "success.status2Content";
  EDionColors2["SUCCESS_STATUS_1_CONTRAST"] = "success.status1Contrast";
  EDionColors2["SUCCESS_STATUS_1_BACKGROUND"] = "success.status1Background";
  EDionColors2["SUCCESS_STATUS_1_CONTENT"] = "success.status1Content";
  EDionColors2["SUCCESS_INFO_CONTRAST"] = "success.infoContrast";
  EDionColors2["SUCCESS_INFO_BACKGROUND"] = "success.infoBackground";
  EDionColors2["SUCCESS_INFO_CONTENT"] = "success.infoContent";
  EDionColors2["SUCCESS_ERROR_CONTRAST"] = "success.errorContrast";
  EDionColors2["SUCCESS_ERROR_BACKGROUND"] = "success.errorBackground";
  EDionColors2["SUCCESS_ERROR_CONTENT"] = "success.errorContent";
  EDionColors2["SUCCESS_WARNING_CONTRAST"] = "success.warningContrast";
  EDionColors2["SUCCESS_WARNING_BACKGROUND"] = "success.warningBackground";
  EDionColors2["SUCCESS_WARNING_CONTENT"] = "success.warningContent";
  EDionColors2["SUCCESS_SUCCESS_CONTRAST"] = "success.successContrast";
  EDionColors2["SUCCESS_SUCCESS_BACKGROUND"] = "success.successBackground";
  EDionColors2["SUCCESS_SUCCESS_CONTENT"] = "success.successContent";
  EDionColors2["SUCCESS_DISABLE_TEXT"] = "success.disableText";
  EDionColors2["SUCCESS_DISABLE"] = "success.disable";
  EDionColors2["SUCCESS_TRANSPARENT"] = "success.transparent";
  EDionColors2["SUCCESS_FOCUS"] = "success.focus";
  EDionColors2["SUCCESS_PRESS"] = "success.press";
  EDionColors2["SUCCESS_HOVER"] = "success.hover";
  EDionColors2["SUCCESS_LOW_ACCENT"] = "success.lowAccent";
  EDionColors2["SUCCESS_ACCENT"] = "success.accent";
  EDionColors2["SUCCESS_ADDITIONAL"] = "success.additional";
  EDionColors2["SUCCESS_LOW_CONTRAST"] = "success.lowContrast";
  EDionColors2["SUCCESS_CONTRAST"] = "success.contrast";
  EDionColors2["SUCCESS_MAIN"] = "success.main";
  EDionColors2["WARNING_STATUS_5_CONTRAST"] = "warning.status5Contrast";
  EDionColors2["WARNING_STATUS_5_BACKGROUND"] = "warning.status5Background";
  EDionColors2["WARNING_STATUS_5_CONTENT"] = "warning.status5Content";
  EDionColors2["WARNING_STATUS_4_CONTRAST"] = "warning.status4Contrast";
  EDionColors2["WARNING_STATUS_4_BACKGROUND"] = "warning.status4Background";
  EDionColors2["WARNING_STATUS_4_CONTENT"] = "warning.status4Content";
  EDionColors2["WARNING_STATUS_3_CONTRAST"] = "warning.status3Contrast";
  EDionColors2["WARNING_STATUS_3_BACKGROUND"] = "warning.status3Background";
  EDionColors2["WARNING_STATUS_3_CONTENT"] = "warning.status3Content";
  EDionColors2["WARNING_STATUS_2_CONTRAST"] = "warning.status2Contrast";
  EDionColors2["WARNING_STATUS_2_BACKGROUND"] = "warning.status2Background";
  EDionColors2["WARNING_STATUS_2_CONTENT"] = "warning.status2Content";
  EDionColors2["WARNING_STATUS_1_CONTRAST"] = "warning.status1Contrast";
  EDionColors2["WARNING_STATUS_1_BACKGROUND"] = "warning.status1Background";
  EDionColors2["WARNING_STATUS_1_CONTENT"] = "warning.status1Content";
  EDionColors2["WARNING_INFO_CONTRAST"] = "warning.infoContrast";
  EDionColors2["WARNING_INFO_BACKGROUND"] = "warning.infoBackground";
  EDionColors2["WARNING_INFO_CONTENT"] = "warning.infoContent";
  EDionColors2["WARNING_ERROR_CONTRAST"] = "warning.errorContrast";
  EDionColors2["WARNING_ERROR_BACKGROUND"] = "warning.errorBackground";
  EDionColors2["WARNING_ERROR_CONTENT"] = "warning.errorContent";
  EDionColors2["WARNING_WARNING_CONTRAST"] = "warning.warningContrast";
  EDionColors2["WARNING_WARNING_BACKGROUND"] = "warning.warningBackground";
  EDionColors2["WARNING_WARNING_CONTENT"] = "warning.warningContent";
  EDionColors2["WARNING_SUCCESS_CONTRAST"] = "warning.successContrast";
  EDionColors2["WARNING_SUCCESS_BACKGROUND"] = "warning.successBackground";
  EDionColors2["WARNING_SUCCESS_CONTENT"] = "warning.successContent";
  EDionColors2["WARNING_DISABLE_TEXT"] = "warning.disableText";
  EDionColors2["WARNING_DISABLE"] = "warning.disable";
  EDionColors2["WARNING_TRANSPARENT"] = "warning.transparent";
  EDionColors2["WARNING_FOCUS"] = "warning.focus";
  EDionColors2["WARNING_PRESS"] = "warning.press";
  EDionColors2["WARNING_HOVER"] = "warning.hover";
  EDionColors2["WARNING_LOW_ACCENT"] = "warning.lowAccent";
  EDionColors2["WARNING_ACCENT"] = "warning.accent";
  EDionColors2["WARNING_ADDITIONAL"] = "warning.additional";
  EDionColors2["WARNING_LOW_CONTRAST"] = "warning.lowContrast";
  EDionColors2["WARNING_CONTRAST"] = "warning.contrast";
  EDionColors2["WARNING_MAIN"] = "warning.main";
  EDionColors2["ERROR_STATUS_5_CONTRAST"] = "error.status5Contrast";
  EDionColors2["ERROR_STATUS_5_BACKGROUND"] = "error.status5Background";
  EDionColors2["ERROR_STATUS_5_CONTENT"] = "error.status5Content";
  EDionColors2["ERROR_STATUS_4_CONTRAST"] = "error.status4Contrast";
  EDionColors2["ERROR_STATUS_4_BACKGROUND"] = "error.status4Background";
  EDionColors2["ERROR_STATUS_4_CONTENT"] = "error.status4Content";
  EDionColors2["ERROR_STATUS_3_CONTRAST"] = "error.status3Contrast";
  EDionColors2["ERROR_STATUS_3_BACKGROUND"] = "error.status3Background";
  EDionColors2["ERROR_STATUS_3_CONTENT"] = "error.status3Content";
  EDionColors2["ERROR_STATUS_2_CONTRAST"] = "error.status2Contrast";
  EDionColors2["ERROR_STATUS_2_BACKGROUND"] = "error.status2Background";
  EDionColors2["ERROR_STATUS_2_CONTENT"] = "error.status2Content";
  EDionColors2["ERROR_STATUS_1_CONTRAST"] = "error.status1Contrast";
  EDionColors2["ERROR_STATUS_1_BACKGROUND"] = "error.status1Background";
  EDionColors2["ERROR_STATUS_1_CONTENT"] = "error.status1Content";
  EDionColors2["ERROR_INFO_CONTRAST"] = "error.infoContrast";
  EDionColors2["ERROR_INFO_BACKGROUND"] = "error.infoBackground";
  EDionColors2["ERROR_INFO_CONTENT"] = "error.infoContent";
  EDionColors2["ERROR_ERROR_CONTRAST"] = "error.errorContrast";
  EDionColors2["ERROR_ERROR_BACKGROUND"] = "error.errorBackground";
  EDionColors2["ERROR_ERROR_CONTENT"] = "error.errorContent";
  EDionColors2["ERROR_WARNING_CONTRAST"] = "error.warningContrast";
  EDionColors2["ERROR_WARNING_BACKGROUND"] = "error.warningBackground";
  EDionColors2["ERROR_WARNING_CONTENT"] = "error.warningContent";
  EDionColors2["ERROR_SUCCESS_CONTRAST"] = "error.successContrast";
  EDionColors2["ERROR_SUCCESS_BACKGROUND"] = "error.successBackground";
  EDionColors2["ERROR_SUCCESS_CONTENT"] = "error.successContent";
  EDionColors2["ERROR_DISABLE_TEXT"] = "error.disableText";
  EDionColors2["ERROR_DISABLE"] = "error.disable";
  EDionColors2["ERROR_TRANSPARENT"] = "error.transparent";
  EDionColors2["ERROR_FOCUS"] = "error.focus";
  EDionColors2["ERROR_PRESS"] = "error.press";
  EDionColors2["ERROR_HOVER"] = "error.hover";
  EDionColors2["ERROR_LOW_ACCENT"] = "error.lowAccent";
  EDionColors2["ERROR_ACCENT"] = "error.accent";
  EDionColors2["ERROR_ADDITIONAL"] = "error.additional";
  EDionColors2["ERROR_LOW_CONTRAST"] = "error.lowContrast";
  EDionColors2["ERROR_CONTRAST"] = "error.contrast";
  EDionColors2["ERROR_MAIN"] = "error.main";
  EDionColors2["INFO_STATUS_5_CONTRAST"] = "info.status5Contrast";
  EDionColors2["INFO_STATUS_5_BACKGROUND"] = "info.status5Background";
  EDionColors2["INFO_STATUS_5_CONTENT"] = "info.status5Content";
  EDionColors2["INFO_STATUS_4_CONTRAST"] = "info.status4Contrast";
  EDionColors2["INFO_STATUS_4_BACKGROUND"] = "info.status4Background";
  EDionColors2["INFO_STATUS_4_CONTENT"] = "info.status4Content";
  EDionColors2["INFO_STATUS_3_CONTRAST"] = "info.status3Contrast";
  EDionColors2["INFO_STATUS_3_BACKGROUND"] = "info.status3Background";
  EDionColors2["INFO_STATUS_3_CONTENT"] = "info.status3Content";
  EDionColors2["INFO_STATUS_2_CONTRAST"] = "info.status2Contrast";
  EDionColors2["INFO_STATUS_2_BACKGROUND"] = "info.status2Background";
  EDionColors2["INFO_STATUS_2_CONTENT"] = "info.status2Content";
  EDionColors2["INFO_STATUS_1_CONTRAST"] = "info.status1Contrast";
  EDionColors2["INFO_STATUS_1_BACKGROUND"] = "info.status1Background";
  EDionColors2["INFO_STATUS_1_CONTENT"] = "info.status1Content";
  EDionColors2["INFO_INFO_CONTRAST"] = "info.infoContrast";
  EDionColors2["INFO_INFO_BACKGROUND"] = "info.infoBackground";
  EDionColors2["INFO_INFO_CONTENT"] = "info.infoContent";
  EDionColors2["INFO_ERROR_CONTRAST"] = "info.errorContrast";
  EDionColors2["INFO_ERROR_BACKGROUND"] = "info.errorBackground";
  EDionColors2["INFO_ERROR_CONTENT"] = "info.errorContent";
  EDionColors2["INFO_WARNING_CONTRAST"] = "info.warningContrast";
  EDionColors2["INFO_WARNING_BACKGROUND"] = "info.warningBackground";
  EDionColors2["INFO_WARNING_CONTENT"] = "info.warningContent";
  EDionColors2["INFO_SUCCESS_CONTRAST"] = "info.successContrast";
  EDionColors2["INFO_SUCCESS_BACKGROUND"] = "info.successBackground";
  EDionColors2["INFO_SUCCESS_CONTENT"] = "info.successContent";
  EDionColors2["INFO_DISABLE_TEXT"] = "info.disableText";
  EDionColors2["INFO_DISABLE"] = "info.disable";
  EDionColors2["INFO_TRANSPARENT"] = "info.transparent";
  EDionColors2["INFO_FOCUS"] = "info.focus";
  EDionColors2["INFO_PRESS"] = "info.press";
  EDionColors2["INFO_HOVER"] = "info.hover";
  EDionColors2["INFO_LOW_ACCENT"] = "info.lowAccent";
  EDionColors2["INFO_ACCENT"] = "info.accent";
  EDionColors2["INFO_ADDITIONAL"] = "info.additional";
  EDionColors2["INFO_LOW_CONTRAST"] = "info.lowContrast";
  EDionColors2["INFO_CONTRAST"] = "info.contrast";
  EDionColors2["INFO_MAIN"] = "info.main";
  EDionColors2["STATUS_1_STATUS_5_CONTRAST"] = "status1.status5Contrast";
  EDionColors2["STATUS_1_STATUS_5_BACKGROUND"] = "status1.status5Background";
  EDionColors2["STATUS_1_STATUS_5_CONTENT"] = "status1.status5Content";
  EDionColors2["STATUS_1_STATUS_4_CONTRAST"] = "status1.status4Contrast";
  EDionColors2["STATUS_1_STATUS_4_BACKGROUND"] = "status1.status4Background";
  EDionColors2["STATUS_1_STATUS_4_CONTENT"] = "status1.status4Content";
  EDionColors2["STATUS_1_STATUS_3_CONTRAST"] = "status1.status3Contrast";
  EDionColors2["STATUS_1_STATUS_3_BACKGROUND"] = "status1.status3Background";
  EDionColors2["STATUS_1_STATUS_3_CONTENT"] = "status1.status3Content";
  EDionColors2["STATUS_1_STATUS_2_CONTRAST"] = "status1.status2Contrast";
  EDionColors2["STATUS_1_STATUS_2_BACKGROUND"] = "status1.status2Background";
  EDionColors2["STATUS_1_STATUS_2_CONTENT"] = "status1.status2Content";
  EDionColors2["STATUS_1_STATUS_1_CONTRAST"] = "status1.status1Contrast";
  EDionColors2["STATUS_1_STATUS_1_BACKGROUND"] = "status1.status1Background";
  EDionColors2["STATUS_1_STATUS_1_CONTENT"] = "status1.status1Content";
  EDionColors2["STATUS_1_INFO_CONTRAST"] = "status1.infoContrast";
  EDionColors2["STATUS_1_INFO_BACKGROUND"] = "status1.infoBackground";
  EDionColors2["STATUS_1_INFO_CONTENT"] = "status1.infoContent";
  EDionColors2["STATUS_1_ERROR_CONTRAST"] = "status1.errorContrast";
  EDionColors2["STATUS_1_ERROR_BACKGROUND"] = "status1.errorBackground";
  EDionColors2["STATUS_1_ERROR_CONTENT"] = "status1.errorContent";
  EDionColors2["STATUS_1_WARNING_CONTRAST"] = "status1.warningContrast";
  EDionColors2["STATUS_1_WARNING_BACKGROUND"] = "status1.warningBackground";
  EDionColors2["STATUS_1_WARNING_CONTENT"] = "status1.warningContent";
  EDionColors2["STATUS_1_SUCCESS_CONTRAST"] = "status1.successContrast";
  EDionColors2["STATUS_1_SUCCESS_BACKGROUND"] = "status1.successBackground";
  EDionColors2["STATUS_1_SUCCESS_CONTENT"] = "status1.successContent";
  EDionColors2["STATUS_1_DISABLE_TEXT"] = "status1.disableText";
  EDionColors2["STATUS_1_DISABLE"] = "status1.disable";
  EDionColors2["STATUS_1_TRANSPARENT"] = "status1.transparent";
  EDionColors2["STATUS_1_FOCUS"] = "status1.focus";
  EDionColors2["STATUS_1_PRESS"] = "status1.press";
  EDionColors2["STATUS_1_HOVER"] = "status1.hover";
  EDionColors2["STATUS_1_LOW_ACCENT"] = "status1.lowAccent";
  EDionColors2["STATUS_1_ACCENT"] = "status1.accent";
  EDionColors2["STATUS_1_ADDITIONAL"] = "status1.additional";
  EDionColors2["STATUS_1_LOW_CONTRAST"] = "status1.lowContrast";
  EDionColors2["STATUS_1_CONTRAST"] = "status1.contrast";
  EDionColors2["STATUS_1_MAIN"] = "status1.main";
  EDionColors2["STATUS_2_STATUS_5_CONTRAST"] = "status2.status5Contrast";
  EDionColors2["STATUS_2_STATUS_5_BACKGROUND"] = "status2.status5Background";
  EDionColors2["STATUS_2_STATUS_5_CONTENT"] = "status2.status5Content";
  EDionColors2["STATUS_2_STATUS_4_CONTRAST"] = "status2.status4Contrast";
  EDionColors2["STATUS_2_STATUS_4_BACKGROUND"] = "status2.status4Background";
  EDionColors2["STATUS_2_STATUS_4_CONTENT"] = "status2.status4Content";
  EDionColors2["STATUS_2_STATUS_3_CONTRAST"] = "status2.status3Contrast";
  EDionColors2["STATUS_2_STATUS_3_BACKGROUND"] = "status2.status3Background";
  EDionColors2["STATUS_2_STATUS_3_CONTENT"] = "status2.status3Content";
  EDionColors2["STATUS_2_STATUS_2_CONTRAST"] = "status2.status2Contrast";
  EDionColors2["STATUS_2_STATUS_2_BACKGROUND"] = "status2.status2Background";
  EDionColors2["STATUS_2_STATUS_2_CONTENT"] = "status2.status2Content";
  EDionColors2["STATUS_2_STATUS_1_CONTRAST"] = "status2.status1Contrast";
  EDionColors2["STATUS_2_STATUS_1_BACKGROUND"] = "status2.status1Background";
  EDionColors2["STATUS_2_STATUS_1_CONTENT"] = "status2.status1Content";
  EDionColors2["STATUS_2_INFO_CONTRAST"] = "status2.infoContrast";
  EDionColors2["STATUS_2_INFO_BACKGROUND"] = "status2.infoBackground";
  EDionColors2["STATUS_2_INFO_CONTENT"] = "status2.infoContent";
  EDionColors2["STATUS_2_ERROR_CONTRAST"] = "status2.errorContrast";
  EDionColors2["STATUS_2_ERROR_BACKGROUND"] = "status2.errorBackground";
  EDionColors2["STATUS_2_ERROR_CONTENT"] = "status2.errorContent";
  EDionColors2["STATUS_2_WARNING_CONTRAST"] = "status2.warningContrast";
  EDionColors2["STATUS_2_WARNING_BACKGROUND"] = "status2.warningBackground";
  EDionColors2["STATUS_2_WARNING_CONTENT"] = "status2.warningContent";
  EDionColors2["STATUS_2_SUCCESS_CONTRAST"] = "status2.successContrast";
  EDionColors2["STATUS_2_SUCCESS_BACKGROUND"] = "status2.successBackground";
  EDionColors2["STATUS_2_SUCCESS_CONTENT"] = "status2.successContent";
  EDionColors2["STATUS_2_DISABLE_TEXT"] = "status2.disableText";
  EDionColors2["STATUS_2_DISABLE"] = "status2.disable";
  EDionColors2["STATUS_2_TRANSPARENT"] = "status2.transparent";
  EDionColors2["STATUS_2_FOCUS"] = "status2.focus";
  EDionColors2["STATUS_2_PRESS"] = "status2.press";
  EDionColors2["STATUS_2_HOVER"] = "status2.hover";
  EDionColors2["STATUS_2_LOW_ACCENT"] = "status2.lowAccent";
  EDionColors2["STATUS_2_ACCENT"] = "status2.accent";
  EDionColors2["STATUS_2_ADDITIONAL"] = "status2.additional";
  EDionColors2["STATUS_2_LOW_CONTRAST"] = "status2.lowContrast";
  EDionColors2["STATUS_2_CONTRAST"] = "status2.contrast";
  EDionColors2["STATUS_2_MAIN"] = "status2.main";
  EDionColors2["STATUS_3_STATUS_5_CONTRAST"] = "status3.status5Contrast";
  EDionColors2["STATUS_3_STATUS_5_BACKGROUND"] = "status3.status5Background";
  EDionColors2["STATUS_3_STATUS_5_CONTENT"] = "status3.status5Content";
  EDionColors2["STATUS_3_STATUS_4_CONTRAST"] = "status3.status4Contrast";
  EDionColors2["STATUS_3_STATUS_4_BACKGROUND"] = "status3.status4Background";
  EDionColors2["STATUS_3_STATUS_4_CONTENT"] = "status3.status4Content";
  EDionColors2["STATUS_3_STATUS_3_CONTRAST"] = "status3.status3Contrast";
  EDionColors2["STATUS_3_STATUS_3_BACKGROUND"] = "status3.status3Background";
  EDionColors2["STATUS_3_STATUS_3_CONTENT"] = "status3.status3Content";
  EDionColors2["STATUS_3_STATUS_2_CONTRAST"] = "status3.status2Contrast";
  EDionColors2["STATUS_3_STATUS_2_BACKGROUND"] = "status3.status2Background";
  EDionColors2["STATUS_3_STATUS_2_CONTENT"] = "status3.status2Content";
  EDionColors2["STATUS_3_STATUS_1_CONTRAST"] = "status3.status1Contrast";
  EDionColors2["STATUS_3_STATUS_1_BACKGROUND"] = "status3.status1Background";
  EDionColors2["STATUS_3_STATUS_1_CONTENT"] = "status3.status1Content";
  EDionColors2["STATUS_3_INFO_CONTRAST"] = "status3.infoContrast";
  EDionColors2["STATUS_3_INFO_BACKGROUND"] = "status3.infoBackground";
  EDionColors2["STATUS_3_INFO_CONTENT"] = "status3.infoContent";
  EDionColors2["STATUS_3_ERROR_CONTRAST"] = "status3.errorContrast";
  EDionColors2["STATUS_3_ERROR_BACKGROUND"] = "status3.errorBackground";
  EDionColors2["STATUS_3_ERROR_CONTENT"] = "status3.errorContent";
  EDionColors2["STATUS_3_WARNING_CONTRAST"] = "status3.warningContrast";
  EDionColors2["STATUS_3_WARNING_BACKGROUND"] = "status3.warningBackground";
  EDionColors2["STATUS_3_WARNING_CONTENT"] = "status3.warningContent";
  EDionColors2["STATUS_3_SUCCESS_CONTRAST"] = "status3.successContrast";
  EDionColors2["STATUS_3_SUCCESS_BACKGROUND"] = "status3.successBackground";
  EDionColors2["STATUS_3_SUCCESS_CONTENT"] = "status3.successContent";
  EDionColors2["STATUS_3_DISABLE_TEXT"] = "status3.disableText";
  EDionColors2["STATUS_3_DISABLE"] = "status3.disable";
  EDionColors2["STATUS_3_TRANSPARENT"] = "status3.transparent";
  EDionColors2["STATUS_3_FOCUS"] = "status3.focus";
  EDionColors2["STATUS_3_PRESS"] = "status3.press";
  EDionColors2["STATUS_3_HOVER"] = "status3.hover";
  EDionColors2["STATUS_3_LOW_ACCENT"] = "status3.lowAccent";
  EDionColors2["STATUS_3_ACCENT"] = "status3.accent";
  EDionColors2["STATUS_3_ADDITIONAL"] = "status3.additional";
  EDionColors2["STATUS_3_LOW_CONTRAST"] = "status3.lowContrast";
  EDionColors2["STATUS_3_CONTRAST"] = "status3.contrast";
  EDionColors2["STATUS_3_MAIN"] = "status3.main";
  EDionColors2["STATUS_4_STATUS_5_CONTRAST"] = "status4.status5Contrast";
  EDionColors2["STATUS_4_STATUS_5_BACKGROUND"] = "status4.status5Background";
  EDionColors2["STATUS_4_STATUS_5_CONTENT"] = "status4.status5Content";
  EDionColors2["STATUS_4_STATUS_4_CONTRAST"] = "status4.status4Contrast";
  EDionColors2["STATUS_4_STATUS_4_BACKGROUND"] = "status4.status4Background";
  EDionColors2["STATUS_4_STATUS_4_CONTENT"] = "status4.status4Content";
  EDionColors2["STATUS_4_STATUS_3_CONTRAST"] = "status4.status3Contrast";
  EDionColors2["STATUS_4_STATUS_3_BACKGROUND"] = "status4.status3Background";
  EDionColors2["STATUS_4_STATUS_3_CONTENT"] = "status4.status3Content";
  EDionColors2["STATUS_4_STATUS_2_CONTRAST"] = "status4.status2Contrast";
  EDionColors2["STATUS_4_STATUS_2_BACKGROUND"] = "status4.status2Background";
  EDionColors2["STATUS_4_STATUS_2_CONTENT"] = "status4.status2Content";
  EDionColors2["STATUS_4_STATUS_1_CONTRAST"] = "status4.status1Contrast";
  EDionColors2["STATUS_4_STATUS_1_BACKGROUND"] = "status4.status1Background";
  EDionColors2["STATUS_4_STATUS_1_CONTENT"] = "status4.status1Content";
  EDionColors2["STATUS_4_INFO_CONTRAST"] = "status4.infoContrast";
  EDionColors2["STATUS_4_INFO_BACKGROUND"] = "status4.infoBackground";
  EDionColors2["STATUS_4_INFO_CONTENT"] = "status4.infoContent";
  EDionColors2["STATUS_4_ERROR_CONTRAST"] = "status4.errorContrast";
  EDionColors2["STATUS_4_ERROR_BACKGROUND"] = "status4.errorBackground";
  EDionColors2["STATUS_4_ERROR_CONTENT"] = "status4.errorContent";
  EDionColors2["STATUS_4_WARNING_CONTRAST"] = "status4.warningContrast";
  EDionColors2["STATUS_4_WARNING_BACKGROUND"] = "status4.warningBackground";
  EDionColors2["STATUS_4_WARNING_CONTENT"] = "status4.warningContent";
  EDionColors2["STATUS_4_SUCCESS_CONTRAST"] = "status4.successContrast";
  EDionColors2["STATUS_4_SUCCESS_BACKGROUND"] = "status4.successBackground";
  EDionColors2["STATUS_4_SUCCESS_CONTENT"] = "status4.successContent";
  EDionColors2["STATUS_4_DISABLE_TEXT"] = "status4.disableText";
  EDionColors2["STATUS_4_DISABLE"] = "status4.disable";
  EDionColors2["STATUS_4_TRANSPARENT"] = "status4.transparent";
  EDionColors2["STATUS_4_FOCUS"] = "status4.focus";
  EDionColors2["STATUS_4_PRESS"] = "status4.press";
  EDionColors2["STATUS_4_HOVER"] = "status4.hover";
  EDionColors2["STATUS_4_LOW_ACCENT"] = "status4.lowAccent";
  EDionColors2["STATUS_4_ACCENT"] = "status4.accent";
  EDionColors2["STATUS_4_ADDITIONAL"] = "status4.additional";
  EDionColors2["STATUS_4_LOW_CONTRAST"] = "status4.lowContrast";
  EDionColors2["STATUS_4_CONTRAST"] = "status4.contrast";
  EDionColors2["STATUS_4_MAIN"] = "status4.main";
  EDionColors2["STATUS_5_STATUS_5_CONTRAST"] = "status5.status5Contrast";
  EDionColors2["STATUS_5_STATUS_5_BACKGROUND"] = "status5.status5Background";
  EDionColors2["STATUS_5_STATUS_5_CONTENT"] = "status5.status5Content";
  EDionColors2["STATUS_5_STATUS_4_CONTRAST"] = "status5.status4Contrast";
  EDionColors2["STATUS_5_STATUS_4_BACKGROUND"] = "status5.status4Background";
  EDionColors2["STATUS_5_STATUS_4_CONTENT"] = "status5.status4Content";
  EDionColors2["STATUS_5_STATUS_3_CONTRAST"] = "status5.status3Contrast";
  EDionColors2["STATUS_5_STATUS_3_BACKGROUND"] = "status5.status3Background";
  EDionColors2["STATUS_5_STATUS_3_CONTENT"] = "status5.status3Content";
  EDionColors2["STATUS_5_STATUS_2_CONTRAST"] = "status5.status2Contrast";
  EDionColors2["STATUS_5_STATUS_2_BACKGROUND"] = "status5.status2Background";
  EDionColors2["STATUS_5_STATUS_2_CONTENT"] = "status5.status2Content";
  EDionColors2["STATUS_5_STATUS_1_CONTRAST"] = "status5.status1Contrast";
  EDionColors2["STATUS_5_STATUS_1_BACKGROUND"] = "status5.status1Background";
  EDionColors2["STATUS_5_STATUS_1_CONTENT"] = "status5.status1Content";
  EDionColors2["STATUS_5_INFO_CONTRAST"] = "status5.infoContrast";
  EDionColors2["STATUS_5_INFO_BACKGROUND"] = "status5.infoBackground";
  EDionColors2["STATUS_5_INFO_CONTENT"] = "status5.infoContent";
  EDionColors2["STATUS_5_ERROR_CONTRAST"] = "status5.errorContrast";
  EDionColors2["STATUS_5_ERROR_BACKGROUND"] = "status5.errorBackground";
  EDionColors2["STATUS_5_ERROR_CONTENT"] = "status5.errorContent";
  EDionColors2["STATUS_5_WARNING_CONTRAST"] = "status5.warningContrast";
  EDionColors2["STATUS_5_WARNING_BACKGROUND"] = "status5.warningBackground";
  EDionColors2["STATUS_5_WARNING_CONTENT"] = "status5.warningContent";
  EDionColors2["STATUS_5_SUCCESS_CONTRAST"] = "status5.successContrast";
  EDionColors2["STATUS_5_SUCCESS_BACKGROUND"] = "status5.successBackground";
  EDionColors2["STATUS_5_SUCCESS_CONTENT"] = "status5.successContent";
  EDionColors2["STATUS_5_DISABLE_TEXT"] = "status5.disableText";
  EDionColors2["STATUS_5_DISABLE"] = "status5.disable";
  EDionColors2["STATUS_5_TRANSPARENT"] = "status5.transparent";
  EDionColors2["STATUS_5_FOCUS"] = "status5.focus";
  EDionColors2["STATUS_5_PRESS"] = "status5.press";
  EDionColors2["STATUS_5_HOVER"] = "status5.hover";
  EDionColors2["STATUS_5_LOW_ACCENT"] = "status5.lowAccent";
  EDionColors2["STATUS_5_ACCENT"] = "status5.accent";
  EDionColors2["STATUS_5_ADDITIONAL"] = "status5.additional";
  EDionColors2["STATUS_5_LOW_CONTRAST"] = "status5.lowContrast";
  EDionColors2["STATUS_5_CONTRAST"] = "status5.contrast";
  EDionColors2["STATUS_5_MAIN"] = "status5.main";
  return EDionColors2;
})(EDionColors || {});
var tokens_default = tokens;
export {
  EDionColorGroups,
  EDionColorNames,
  EDionColors,
  EThemeGradients,
  tokens_default as default
};
